/* eslint-disable no-undef */
/*global google*/
import React, { Component } from "react";
// import axios from "axios";
import dynamic from "next/dynamic";
import Map from "../components/NhMap/map";
// import Neighbourhood from "../components/NhMap/neighbourhood";
import Layout from "../container";
// import Cities from "../components/NhMap/cities";
// import Homes from "../components/NhMap/homes";
// import Headers from "../components/NhMap/header";
import Head from "next/head";
import {
  Container,
  Divider,
  Grid,
  Input,
  Tab,
  Button,
  Menu,
  Item,
  Icon,
} from "semantic-ui-react";
//import PlacesAutocomplete from 'react-places-autocomplete';
import "isomorphic-fetch";
// import { VscClose } from "react-icons/vsc";
import Router from "next/router";
// import { Auth } from "aws-amplify";
import {
  getCurrentUser,
  fetchAuthSession,
  fetchUserAttributes,
  signIn,
} from "aws-amplify/auth";
// import SearchBox from "../components/NhMap/SearchBox";
// Removed LoginModal, SignupModal, Segmant - not used in this component
import ErrorBoundary from "../components/ErrorBoundary";
// import Link from "next/link";
// import cookie from "react-cookies";
// import { LandingFooter } from "../pagecomponents/Welcome";
import {
  addSavedhomes,
  // getAllSavedHomelist,
  deleteSavedhomes,
} from "../modules/Graphql/Savehomegraphql";
// import { getwalkscore } from "../modules/Graphql/walkscoregrapgql";
import {
  // addUser,
  // updateUser,
  // deleteUser,
  getAllUserList,
} from "../modules/Graphql/usergraphql";
// import SelectedNeighbourhood from "../components/SelectedNeighbourhood";
// import SelectedHome from "../components/SelectedHome";
// import { renderToStringWithData } from "react-apollo";
import {
  addsavedneighborhoodbyuser,
  // checkSavedNeighborhoodbyuserStatus,
} from "../modules/Graphql/savedneighborhoodbyusergraphql";
import {
  getNeighborSearch,
  addNeighbourSearch,
} from "../modules/Graphql/neighborsearchgraphql";
import { getAllneighborboundrieslist } from "../modules/Graphql/neighborhoodboundriesgraphql";

// import CognitoConfig from "../common/Cognitoconfig";
import { addsavedcitybyuser } from "../modules/Graphql/savedcitybyusergraphql";
// import { getdetailhomelist } from "../modules/Graphql/Detailhomegraphql";
// import Joyride, { STATUS, Step } from "react-joyride";
import FeedbackForm from "../common/FeedbackForm";
// import { LandingGrids } from "../pagecomponents/Welcome";
import { nhmapgridData } from "../pagecomponents/Welcome/landingData.json";
// import Modal from "react-modal";
// import LandingVideo from "../pagecomponents/Welcome/LandingVideo";
import PlatformService from "../common/PlatformService";
// import ViewToggle from "../components/ViewToggle";
// Amplify.configure(CognitoConfig);

// Lazy load component - only loads when needed
const Neighbourhood = dynamic(() => import("../components/NhMap/neighbourhood"), {
  ssr: false,
  loading: () => <div style={{ textAlign: 'center', padding: '20px' }}>Loading neighbourhood...</div>
});
const Cities = dynamic(() => import("../components/NhMap/cities"), {
  ssr: false,
  loading: () => <div style={{ textAlign: 'center', padding: '20px' }}>Loading city...</div>
});
const Homes = dynamic(() => import("../components/NhMap/homes"), {
  ssr: false,
  loading: () => <div style={{ textAlign: 'center', padding: '20px' }}>Loading homes...</div>
});
const LandingFooter = dynamic(
  () => import("../pagecomponents/Welcome").then((mod) => mod.LandingFooter),
  {
    ssr: false,
    loading: () => <div>Loading...</div>,
  }
);
const SelectedNeighbourhood = dynamic(() => import("../components/SelectedNeighbourhood"), {
  ssr: false,
  loading: () => <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>
});
const SelectedHome = dynamic(() => import("../components/SelectedHome"), {
  ssr: false,
  loading: () => <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>
});
const LandingVideo = dynamic(() => import("../pagecomponents/Welcome/LandingVideo"), {
  ssr: false,
  loading: () => <div style={{ textAlign: 'center', padding: '20px' }}>Loading video...</div>
});
const ViewToggle = dynamic(() => import("../components/ViewToggle"), {
  ssr: false,
  loading: () => <div style={{ textAlign: 'center' }}>Loading...</div>
});
const Modal = dynamic(() => import("react-modal"), {
  ssr: false,
  loading: () => <div>Loading...</div>,
});

const minLat = 37.6988;
const minLng = -122.34147;
const maxLat = 37.8842;
const maxLng = -122.112033;
const tabPadding = 17.5;

// const customStyles = {
//   content: {
//     top: "50%",
//     left: "37%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)",
//     width: "50%",
//     //height: "100%",
//     backgroundColor: "rgba(55, 55, 54, 0.8)",
//     borderRadius: "15px",
//     border: "1px solid #000",
//     backgroundImage:
//       "linear-gradient(rgba(100,100,100,0.8), rgba(151,151,151,0.9)) !important",
//     padding: "0px",
//     overflow: "hidden",
//   },
//   overlay: {
//     background: "rgba(255, 255, 255, 0.6)",
//   },
// };

class NhMap extends React.PureComponent {
  searchaddress;
  constructor(props) {
    super(props);
    this.topScroll = React.createRef();
    this._preventEvent = false;
    this.contentScroll = React.createRef();
    this.handleInputChange = this.handleInputChange.bind(this);
    this.detectHeight = this.detectHeight.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeRHP = this.handleChangeRHP.bind(this);
    this.handleChangeRHP2 = this.handleChangeRHP2.bind(this);
    this.handleAddressChange = this.handleAddressChange.bind(this);
    this.renderData = this.renderData.bind(this);
    this.checkUser = this.checkUser.bind(this);
    this.checkUsergo = this.checkUsergo.bind(this);
    this.handlecheckpersonal = this.handlecheckpersonal.bind(this);
    this.handleHoverRight = this.handleHoverRight.bind(this);
    this.handleClickRight = this.handleClickRight.bind(this);
    this.handleCityHoverRight = this.handleCityHoverRight.bind(this);
    this.handleCityUnHoverRight = this.handleCityUnHoverRight.bind(this);
    this.handleUnhoverRight = this.handleUnhoverRight.bind(this);
    this.handleHomesUnhoverRight = this.handleHomesUnhoverRight.bind(this);
    this.handleHomesHoverRight = this.handleHomesHoverRight.bind(this);
    this.filterHome = this.filterHome.bind(this);
    this.filterhomecounthandler = this.filterhomecounthandler.bind(this);
    // this.renderData(this.state.lhpFactor, 1);
    this.changeZoom = this.changeZoom.bind(this);
    this.handlesinglecancel = this.handlesinglecancel.bind(this);
    this.handletabclick = this.handletabclick.bind(this);
    this.homesRef = React.createRef();
    this.neighborRef = React.createRef();
    this.tabRef = null;
    this.mapComponentRef = null;
    this.savedrighthome = [];
    this.myInput = React.createRef();
    this.schooltext = "";
    this.amentiestext = "";
    this.customStyles = {
      content: {
        top: "50%",
        left: "37%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "50%",
        height: "auto",
        backgroundColor: "transparent",
        borderRadius: "15px",
        border: "1px solid #000",
        padding: "0px",
        overflow: "hidden",
      },
      overlay: {
        background: "rgba(255, 255, 255, 0.6)",
      },
    };

    this.updateStyles = this.updateStyles.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateStyles);
  }

  componentDidUpdate() {
    this.updateStyles();
  }
  updateStyles() {
    if (window.innerWidth <= 500) {
      this.customStyles.content.width = "80%";
      this.customStyles.content.height = "100%";
      this.customStyles.content.border = "none !important";
      this.customStyles.content.backgroundColor = "transparent";
      this.customStyles.content.borderRadius = "0";
      this.customStyles.content.padding = "50px";
      this.customStyles.content.overflow = "auto";
    } else if (window.innerWidth > 500 && window.innerWidth < 610) {
      this.customStyles.content.width = "80% !important";
      this.customStyles.content.padding = "20px";
      this.customStyles.content.backgroundColor = "rgba(55, 55, 54, 0.8)";
    } else if (window.innerWidth <= 650 && window.innerWidth > 610) {
      this.customStyles.content.padding = "0px";
      this.customStyles.content.width = "80%";
      this.customStyles.content.height = "100%";
      this.customStyles.content.border = "none !important";
      this.customStyles.content.backgroundColor = "transparent";
      this.customStyles.content.borderRadius = "0";
    } else if (window.innerWidth > 785 && window.innerWidth < 800) {
      this.customStyles.content.left = "50%";
      this.customStyles.content.border = "none !important";
      this.customStyles.content.backgroundColor = "rgba(55, 55, 54, 0.8)";
    } else if (window.innerWidth > 800 && window.innerWidth < 1100) {
      this.customStyles.content.width = "50%";
      this.customStyles.content.border = "none !important";
      this.customStyles.content.backgroundColor = "rgba(55, 55, 54, 0.8)";
      this.customStyles.content.left = "50%";
    } else if (window.innerWidth >= 1100 && window.innerWidth < 1300) {
      this.customStyles.content.left = "50%";
      this.customStyles.content.width = "80%";
      this.customStyles.content.border = "none !important";
      this.customStyles.content.backgroundColor = "rgba(55, 55, 54, 0.8)";
    } else {
      this.customStyles.content.left = "50%";
      this.customStyles.content.width = "auto";
      this.customStyles.content.paddingLeft = "20px";
      this.customStyles.content.paddingRight = "20px";
      this.customStyles.content.border = "none !important";
      this.customStyles.content.backgroundColor = "rgba(55, 55, 54, 0.8)";
    }
  }

  state = {
    address: this.props.query ? this.props.query.address : "",
    // Default to San Francisco Bay Area coordinates for immediate map rendering
    lat: 37.63394653644841,
    lng: -122.24727600390625,
    zoom: 11,
    lhpFactor: 0,
    rhpFactor: 1,
    cities: [],
    neighborhood: [],
    selectedNeighbour: false,
    homes: [],
    height: 0,
    // Set default mapHeight for immediate map rendering (will be recalculated on mount)
    mapHeight: 600,
    hMarkers: [],
    sMarkers: [],
    schoolBool: false,
    filterHome: false,
    loggedin: false,
    smodal: false,
    lmodal: false,
    userdetails: "",
    email_err_status: false,
    email_err_msg: "",
    pwd_err_status: false,
    pwd_err_msg: "",
    persSeachData: "",
    homedata: [],
    singlehomedata: [],
    singleneighbordata: [],
    singlecitydata: [],
    walkscoredata: "",
    neighbordata: [],
    getdatafromhomes: [],
    activeindexes: "",
    userdata: "",
    savedhomedata: [],
    heart: [],
    nhheart: [],
    cityheart: [],
    rightsidehome: "",
    activeNhId: "",
    activeHomeId: "",
    activeCityId: "",
    loaderdisplayicon: "",
    tabdisplay: "none",
    eletabdispay: "none",
    middletabdisplay: "none",
    hightabdisplay: "none",
    amenitiestabdisplay: "none",
    editabdisplay: "none",
    pricetabdisplay: "none",
    townctrtabdisplay: "none",
    publictabdisplay: "none",
    walaktabdisplay: "none",
    curbtabdisplay: "none",
    userId: "",
    schooltxt: "School",
    eletxt: "Elementary",
    middletxt: "Middle",
    hightxt: "High",
    allschooltxt: "All Schools",
    amenitiestxt: "Amenities",
    townctrtxt: "Near Merchants",
    publictxt: "Public Spaces",
    walktxt: "Walkable Streets",
    curbtxt: "Curb Appeal",
    allamenitiestxt: "All Amenities",
    pricemaintxt: "Price",
    pricetxt: "Price",
    valuetxt: "Value",
    savedneighbordata: [],
    savedcitydata: [],
    counts: 0,
    isthirdclick: false,
    loaderactive: false,
    lastzoom: 14,
    sactive: "",
    amenitiesactive: "",
    personalactive: "",
    priceactive: "",
    personal_txt: "Personalize Search",
    recommendedneighbordata: [],
    prefindval: "",
    preuserid: "",
    schoolleft: 0,
    amenitiesleft: 0,
    editleft: 0,
    priceleft: 0,
    schoolwidth: 0,
    amenitieswidth: 0,
    editwidth: 0,
    metericon: "overall-white.svg",
    shieldicon: "safety-grey.svg",
    walkingicon: "undervalued-grey.svg",
    buildingicon: "amenities-grey.svg",
    treeicon: "appreciation-grey.svg",
    peopleicon: "people.svg",
    home_moneyicon: "price-grey.svg",
    personicon: "personalized-grey.svg",
    schoolicon: "school-grey.svg",
    hoverdnhid: "",
    unhoverd: false,
    viewMap: true,
    isMobile: false,
    isTablet: false,
    isDeviceChecked: null,
    displayMapMask: false,
    schoolbar_val: 50,
    crimebar_val: 50,
    townbar_val: 50,
    curbbar_val: 50,
    walkbar_val: 50,
    commbar_val: 50,
    valuebar_val: 50,
    pricemax_val: 0,
    pricemin_val: 0,
    is_personalize: false,
    is_loaded: false,
    personalize_data: [],
    is_from_login: false,
    emailval: "",
    passval: "",
    isChecked: false,
    is_loading: false,
    filter_homes_count: 0,
    selectedpersonaldata: [],
    is_disable_lhp: true,
    boundrycoordsdata: [],
    is_from_personal: false,
    top_first_sec: 0,
    top_second_sec: 0,
    top_third_sec: 0,
    is_dispaly_top_text: true,
    nhsaved: 0,
    is_edit_click: false,
    previous_active: "npi",
    isTab: false,
    run: false,
    landingpopup: false,
    isplusatingopen: false,
    isExpanded: false,
    startY: 0,
    currentY: 0,
    translateY: 0,
    dragging: false,
    drawerHeight: 0,
    moved: false,
    CentercityName: "",
    CentercountyName: "",
    postalcityfullname: "",
    countyfullname: "",
    steps: [
      {
        content: <h2>Map neighborhoods ranked by one of these factors</h2>,
        floaterProps: {
          disableAnimation: true,
        },
        spotlightPadding: 10,
        target: "body .tab_main_top",
        hideBackButton: true,
        disableBeacon: true,
      },
      {
        content: (
          <h2>
            Click on a neighborhood in the map to open a neighborhood page with
            scores and reviews
          </h2>
        ),
        placement: "center",
        // styles: {
        //   options: {
        //     width: 300,
        //   },
        // },
        target: "#map",
        locale: { skip: "" },
        showSkipButton: false,
        //hideBackButton: true,
        // title: "Check awesome map",
      },
      {
        content: (
          <h2>View top cities, neighborhoods, and homes from the map area</h2>
        ),
        placement: "left",
        target: ".map_right_blk",
        //hideBackButton: true,
        locale: { last: "Done", skip: "" },

        //title: "Explore more",
      },
      // {
      //   content: (
      //     <div>
      //       <h3>
      //         All about the details of neighborhoods, city and homes based on
      //         the tab selection
      //       </h3>
      //       <img src="https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExMDNpdmRndDRmNWJ0ZHZ4dDk3ZXZleWN4MzR4MXBhZjgxY3liZmh0aiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/73ZdizxtiOgP6qjriv/200w.gif" />
      //     </div>
      //   ),
      //   placement: "left",
      //   target: ".map_right_blk .tab_content",
      // },
    ],
    visibleSet: 1,
    citydata: [],
  };

  // static getInitialProps = ({ query }) => {
  //   return { query };
  // };
  // handleTouchStart = (e) => {
  //   this.setState({
  //     startY: e.touches[0].clientY,
  //     dragging: true,
  //     moved: false,
  //   });
  // };

  // handleTouchMove = (e) => {
  //   const currentY = e.touches[0].clientY;
  //   const diffY = currentY - this.state.startY;

  //   // Track if it has moved significantly
  //   if (Math.abs(diffY) > 5 && !this.state.moved) {
  //     this.setState({ moved: true });
  //   }

  //   if (!this.state.dragging || !this.state.moved) return;

  //   let translateY = diffY;

  //   if (!this.state.isExpanded && diffY < 0) {
  //     translateY = Math.max(diffY, -window.innerHeight * 0.9);
  //   } else if (this.state.isExpanded && diffY > 0) {
  //     translateY = Math.min(diffY, window.innerHeight * 0.9);
  //   } else {
  //     translateY = 0;
  //   }

  //   this.setState({ translateY });
  // };

  // handleTouchEnd = () => {
  //   const { translateY, isExpanded, moved } = this.state;
  //   const threshold = 100;

  //   if (!moved) {
  //     // It's a tap — delay resetting transform to avoid blocking click
  //     setTimeout(() => {
  //       this.setState({ translateY: 0, dragging: false });
  //     }, 50); // Delay just enough for iOS to register the click
  //     return;
  //   }

  //   // Handle drag logic
  //   if (!isExpanded && translateY < -threshold) {
  //     this.setState({ isExpanded: true, translateY: 0, dragging: false });
  //   } else if (isExpanded && translateY > threshold) {
  //     this.setState({ isExpanded: false, translateY: 0, dragging: false });
  //   } else {
  //     setTimeout(() => {
  //       this.setState({ translateY: 0, dragging: false });
  //     }, 50);
  //   }
  // };

  handleViewChange = (view) => {
    if (view === "Top Lists" && this.state.postalcityfullname !== "") {
      window.open(`/Nhranking/best-overall/${this.state.postalcityfullname}`);
    }
  };

  handleToggleExpand = () => {
    this.setState((prev) => ({
      isExpanded: !prev.isExpanded,
      translateY: 0,
    }));
  };

  handleCollapseFromMapButton = () => {
    this.setState({ isExpanded: false });
  };

  closeLandingmodal = () => {
    this.setState({ landingpopup: false });
    this.setState({ isplusatingopen: true });
    localStorage.setItem("landingPopupClosed", false);
  };

  handlePlusatingClick = () => {
    this.setState({ landingpopup: true });
    this.setState({ isplusatingopen: false });
  };
  handleClickStart = (event) => {
    event.preventDefault();

    this.setState({
      run: true,
    });
  };

  handleJoyrideCallback = (data) => {
    const { status, type } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
    if (finishedStatuses.includes(status)) {
      this.setState({ run: false });
      localStorage.setItem("is_user_skip_ride", "Y");
    }

    // logGroup(type, data);
  };

  // Helper method to get map reference from either direct ref or Tab's refs
  getMapRef = () => {
    // Try direct ref first (most reliable)
    if (this.mapComponentRef) {
      return this.mapComponentRef;
    }
    // Fall back to Tab's string refs
    if (this.tabRef && this.tabRef.refs && this.tabRef.refs.map) {
      return this.tabRef.refs.map;
    }
    return null;
  };

  handlesinglecancel = () => {
    this.getMapRef()?.oncloseclearpolysingle();
    this.setState({ singleneighbordata: [] });
  };
  filterhomecounthandler = (getfilterhomes) => {
    if (getfilterhomes && getfilterhomes.length > 0) {
      this.setState({ filter_homes_count: getfilterhomes.length });
    } else {
      this.setState({ filter_homes_count: 0 });
    }
  };
  savedhomehandler = (getsavedhome) => {
    this.setState({ nhsaved: this.state.nhsaved + 1 });
    this.setState({ savedhomedata: getsavedhome });
    if (this.homesRef?.current?.setsavedData) {
      this.homesRef?.current?.setsavedData(getsavedhome);
    }
    this.getrightsavedhomedata();
  };
  savedneighborhandler = (getsavedneighbor) => {
    this.setState({ nhsaved: this.state.nhsaved + 1 });
    this.setState({ savedneighbordata: getsavedneighbor });
    if (this.homesRef?.current?.setsavedData) {
      this.homesRef?.current?.setsavedData(getsavedneighbor);
    }
  };
  recommendedneighborhandler = (getrecommendedneighbor) => {
    this.setState({ recommendedneighbordata: getrecommendedneighbor });
    if (this.homesRef?.current?.setrecommendedneighborData) {
      this.homesRef?.current?.setrecommendedneighborData(getrecommendedneighbor);
    }
  };
  savedcityhandler = (getsavedcity) => {
    this.setState({ nhsaved: this.state.nhsaved + 1 });
    this.setState({ savedcitydata: getsavedcity });
    if (this.homesRef?.current?.setsavedData) {
      this.homesRef.current?.setsavedData(getsavedcity);
    }
  };
  mapChangeHandler = (fetchhomes) => {
    this.setState({ homedata: fetchhomes });
    if (this.homesRef?.current?.setData) {
      this.homesRef?.current?.setData(fetchhomes);
    }
    if (this.homesRef?.current?.setsavedData) {
      this.homesRef?.current?.setsavedData(this.state.savedhomedata);
    }
    this.setState({ homesdata: fetchhomes });

    //setTimeout(() => this.getrightsavedhomedata(), 1000);
    this.getrightsavedhomedata();
    this.getrightsavednhdata();
    this.getrightsavedsavenhdata();
    this.getrightsavedcitydata();
  };

  singleCityHandler = (fetchdatascity) => {
    //this.homesRef.current.setselectedcityData(fetchdatas);
    this.setState({ singlecitydata: fetchdatascity });
    if (this.homesRef?.current?.setselectedcityData) {
      this.homesRef?.current?.setselectedcityData(fetchdatascity);
    }
  };
  singleClickHandler = () => {
    if (this.state.rhpFactor !== 1) {
      this.setState({ rhpFactor: 1 });
    }
  };
  checkrhptabHandler = () => {
    return this.state.rhpFactor;
  };
  singleNeighborHandler = (fetchdatas, repeat) => {
    this.setState({ singleneighbordata: fetchdatas });
    // if (this.state.rhpFactor !== 1) {
    //   this.setState({ rhpFactor: 1 });
    // }
    // let activeNhId = this.state.activeNhId;
    // if (fetchdatas.length != 0) {
    /*const getdatanew1 = {
        "start": 0,
        "limit": 1,
        "orderBy": fetchdatas[0].latitude,
        "order": fetchdatas[0].longitude,
        "fields": [{
          "name": "",
          "value": "",
          "operator": ""
        }]
      }
     
      getwalkscore(getdatanew1)
        .then(
          result => {
            
           this.setState({walkscoredata:result.data.getwalkscore.walkscore})
           
            //propsnew.singleNeighbor(result.data.getwalkscore)
          }).catch(error => {
          })  */
    //   this.setState({ isthirdclick: false });
    //   if (fetchdatas[0].id === activeNhId) {
    //     let counts = 0;
    //     this.setState({ counts: this.state.counts + 1 }, () => {
    //       counts = this.state.counts;
    //     });

    //     if (repeat === "go") {
    //       this.setState({
    //         singleneighbordata: fetchdatas,
    //       });
    //     } else if (counts >= 2) {
    //       this.setState({ isthirdclick: true });
    //       this.setState({ singleneighbordata: [] });
    //       this.setState({ counts: 0 });
    //     } else {
    //       this.setState({ isthirdclick: false });
    //       this.setState({
    //         singleneighbordata: fetchdatas,
    //         activeNhId: fetchdatas[0].id,
    //       });
    //       if (repeat === undefined && repeat !== "go") {
    //       }
    //     }
    //   } else {
    //     this.setState({
    //       singleneighbordata: fetchdatas,
    //       activeNhId: fetchdatas[0].id,
    //     });
    //     this.setState({
    //       rhpFactor: 1,
    //     });
    //     this.setState({ counts: 0 });
    //   }
    //   // this.setState({
    //   //   rhpFactor: 1,
    //   // },function(){this.setState({
    //   //   rhpFactor: 1})});
    //   this.renderData(this.state.lhpFactor, 1);
    // } else {
    //   this.setState({ singleneighbordata: fetchdatas });
    // }
  };

  singleHomeHandler = (fetchdatas, additionaldata) => {
    let activeHomeId = this.state.activeHomeId;

    if (fetchdatas.length != 0) {
      if (
        fetchdatas[0].ListingKeyNumeric === activeHomeId &&
        additionaldata != ""
      ) {
        this.setState({
          singlehomedata: fetchdatas,
          activeHomeId: fetchdatas[0].ListingKeyNumeric,
        });
        window.open(
          `/DetailsListing/?id=${fetchdatas[0].ListingKeyNumeric}`,
          "_blank",
        );
      } else {
        this.setState({
          singlehomedata: fetchdatas,
          activeHomeId: fetchdatas[0].ListingKeyNumeric,
        });
      }
      this.setState(
        {
          rhpFactor: 2,
        },
        function () {
          this.setState({
            rhpFactor: 2,
          });
        },
      );
      this.renderData(this.state.lhpFactor, 2);
    } else {
      this.setState({ singlehomedata: fetchdatas });
    }
  };

  getCenterCityname = (cityname, postalcityfullname) => {
    this.setState({ CentercityName: cityname });
    this.setState({ postalcityfullname: postalcityfullname });
  };
  getCenterCountyname = (countyname, countyfullname) => {
    this.setState({
      CentercountyName: countyname,
      countyfullname: countyfullname,
    });
  };
  NeighbordataHandler = (fetchdatas, selectedTab) => {
    // this.props.neighbors(storedNames);

    if (fetchdatas.length > 0) {
      this.setState({ loaderdisplayicon: "done" });
    } else {
      this.setState({ loaderdisplayicon: "No data" });
    }
    if (this.homesRef?.current?.setData) {
      this.homesRef.current.setData(fetchdatas);
      // this.homesRef.current.setsavedData(this.state.savedhomedata);
    }
    if (this.homesRef?.current?.setsavedData) {
      // this.homesRef.current.setData(fetchdatas);
      this.homesRef.current.setsavedData(this.state.savedhomedata);
    }
    if (selectedTab === "nh") {
      this.setState({ neighborhood: fetchdatas });
      this.setState({ neighbordata: fetchdatas });
    } else if (selectedTab === "city") {
      this.setState({ citydata: fetchdatas });
    }

    //setTimeout(() => this.getrightsavedhomedata(), 1000);
    this.getrightsavedhomedata();
    this.getrightsavednhdata();
    this.getrightsavedsavenhdata();
    this.getrightsavedcitydata();
  };

  /*checkCookie = () => {
    let cookiestring = cookie.load('map-cookie');
    if(cookiestring !== undefined) {
      this.getMapRef()?.refreshMap3(this.props.query.address)
    } else {
      this.getMapRef()?.refreshMap(this.props.query.address);
    }
  }*/

  /**
   * Handle window size changes and update device-related state variables
   * Combines both window size detection and platform/user-agent detection for accurate device classification
   *
   * Breakpoints (window.innerWidth):
   * - Mobile: <= 425px
   * - Tablet: 426px - 1000px
   * - Small Desktop (isTab): 1001px - 1237px
   * - Desktop: > 1237px
   *
   * Also considers:
   * - User Agent detection (mobile/tablet/desktop)
   * - Device category from PlatformService
   */
  handleWindowSizeChange = () => {
    // Only run on client-side
    if (typeof window === 'undefined') return;

    const width = window.innerWidth;

    // Get platform information from User Agent and device capabilities
    const platform = PlatformService.getPlatformInfo();
    const { deviceType, devicecategory } = platform;

    // Determine if device is mobile based on:
    // 1. Window width <= 425px OR
    // 2. User Agent indicates mobile device OR
    // 3. Device category is phone
    const isMobile =
      width <= 425 ||
      deviceType === "mobile" ||
      devicecategory === "phone";

    // Determine if device is tablet based on:
    // 1. Window width between 426px and 1000px (and NOT mobile) OR
    // 2. User Agent indicates tablet device OR
    // 3. Device category is tablet
    const isTablet =
      (!isMobile && width > 425 && width <= 1000) ||
      (deviceType === "tablet" || devicecategory === "tablet");

    // Small desktop/large tablet: width between 1001px and 1237px
    // This is used for layouts that need adjustment on smaller desktops
    // Only applies if NOT mobile and NOT tablet
    const isTab = width <= 1237 && !isMobile && !isTablet;

    // Batch state update for better performance
    this.setState({
      isMobile,
      isTablet,
      isTab,
      isDeviceChecked: true,
    });

    //// Old changes
    // const { os, device, deviceName, deviceType, devicecategory } =
    //   PlatformService.getPlatformInfo();

    // if (deviceType === "mobile" || devicecategory === "phone") {
    //   this.setState({ isMobile: true });
    // } else if (deviceType === "tablet" || devicecategory === "tablet") {
    //   this.setState({ isMobile: false });
    // } else {
    //   this.setState({ isMobile: false });
    // }
    // // this.setState({ isMobile: window.innerWidth <= 767 });
    // this.setState({ isTab: window.innerWidth <= 1237 });
    // this.setState({
    //   isTablet: window.innerWidth >= 768 && window.innerWidth <= 1000,
    // });
    // this.setState({ isDeviceChecked: true });
  };

  resize = () => this.forceUpdate();

  addpersoanldata = () => {
    const local_personaldata = JSON.parse(
      localStorage.getItem("personal_data"),
    );
    if (local_personaldata && local_personaldata !== undefined) {
      const adddata = {
        userId: this.state.userId,
        schoolScore: local_personaldata.schoolScore,
        towncenter: local_personaldata.towncenter,
        crimeRate: local_personaldata.crimeRate,
        walkability: local_personaldata.walkability,
        commbar_val: local_personaldata.publicspaces,
        curbAppeal: local_personaldata.curbAppeal,
        valueIndex: local_personaldata.valueIndex,
        pricemax: local_personaldata.pricemin,
        pricemin: local_personaldata.pricemax,
        publicspaces: local_personaldata.publicspaces,
        //mindisplay:true,
        //redirectval:prevData.findval
      };

      addNeighbourSearch(adddata).then((result) => {
        if (result.data.createNeighbourSearch.success === true) {
        } else if (result.data.createNeighbourSearch.success === false) {
        }
      });
    }
  };

  /**
   * Helper method to wait for Google Maps API to load with optimized checking
   * Uses fast polling with requestAnimationFrame for best performance
   */
  waitForGoogleMaps = () => {
    return new Promise((resolve) => {
      // If already loaded, resolve immediately
      if (window.google && window.google.maps) {
        resolve();
        return;
      }

      // Use requestAnimationFrame for faster, more efficient polling
      let startTime = performance.now();
      const maxWaitTime = 10000; // 10 seconds max wait

      const checkGoogleMaps = () => {
        if (window.google && window.google.maps) {
          resolve();
          return;
        }

        // Check if we've exceeded max wait time
        if (performance.now() - startTime > maxWaitTime) {
          console.warn('Google Maps API load timeout - proceeding anyway');
          resolve();
          return;
        }

        // Use requestAnimationFrame for smoother, faster checking
        requestAnimationFrame(checkGoogleMaps);
      };

      // Start checking immediately
      requestAnimationFrame(checkGoogleMaps);
    });
  };

  async componentDidMount() {
    // Set correct map height immediately for faster rendering
    this.detectHeight();
    this.handleWindowSizeChange();

    // Hide the initial loading screen immediately for faster perceived performance
    requestAnimationFrame(() => {
      const loadingScreen = document.getElementById('initial-loading-screen');
      if (loadingScreen) {
        loadingScreen.classList.add('hidden');
        setTimeout(() => {
          if (loadingScreen.parentNode) {
            loadingScreen.parentNode.removeChild(loadingScreen);
          }
        }, 10);
      }
    });

    // Wait for Google Maps API to load before proceeding
    await this.waitForGoogleMaps();

    // Show map immediately after Google Maps is loaded to prevent blinking
    this.setState({ is_loaded: true });

    const google = window.google;
    if (google && google != undefined) {
      const is_skipped = localStorage.getItem("is_user_skip_ride");
      if (is_skipped === undefined || is_skipped === null) {
        setTimeout(() => this.setState({ run: true }), 1000);
      }

      const isPopupClosed = JSON.parse(
        localStorage.getItem("landingPopupClosed"),
      );
      this.setState({ landingpopup: isPopupClosed === false ? false : true });
      this.setState({
        isplusatingopen: isPopupClosed === false ? true : false,
      });

      window.addEventListener("beforeunload", (ev) => {
        localStorage.removeItem("savedhomeclickdata");
        localStorage.removeItem("savednhclickdata");
        localStorage.removeItem("savedcityclickdata");
      });
      localStorage.setItem("previous_url", window.location.href);

      window.addEventListener("resize", this.updateStyles);
      this.updateStyles();
      window.addEventListener("resize", this.handleWindowSizeChange);

      this.setState({ is_loading: false });
      if (localStorage.checkbox === "true" && localStorage.email !== "") {
        this.setState({
          isChecked: true,
          emailval: localStorage.email,
          passval: localStorage.password,
        });
      }

      const searchParams = new URLSearchParams(window.location.search);
      const mainUrl = window.location.href;
      const findparams = "address=";
      let hasAddressParam = false;
      if (mainUrl.includes(findparams)) {
        this.searchaddress = Router.asPath;
        let newStr = this.searchaddress.replace("%20", "");
        const location = window.location.href.replace(/%20/g, " ");
        const finaladdress = location.split(findparams).pop();
        this.searchaddress = finaladdress;
        hasAddressParam = true;
      }

      // ✅ Amplify v6 replacement - Process authentication and initial data loading
      await this.processAuthenticationAndLoadData();

      //     /**
      //    try {
      //      const user = await getCurrentUser(); // gives you { username, userId, signInDetails }
      //      const session = await fetchAuthSession(); // gives you idToken, accessToken, refreshToken

      //      const attributes = session.tokens?.idToken?.payload || {}; // contains email, given_name, etc.

      //      const userdetails = Object.values(attributes);

      //      localStorage.setItem(
      //        "userdetails",
      //        JSON.stringify({
      //          role: userdetails[0],
      //          id: userdetails[1],
      //          status: userdetails[2],
      //          first_name: userdetails[3],
      //          s_id: userdetails[4],
      //          last_name: userdetails[5],
      //          pwd: userdetails[6],
      //          email: userdetails[7],
      //        }),
      //      );

      //      this.setState({ userdata: userdetails });

      //      if (userdetails[2] === true) {
      //        // window.location.href = '/login';

      //        this.setState({
      //          userdetails: userdetails,
      //          loggedin: true,
      //        });

      //        const getdata = {
      //          start: 0,
      //          limit: 10,
      //          orderBy: "email",
      //          order: "ASC",
      //          fields: [{ name: "email", value: userdetails[7], operator: "=" }],
      //        };
      //        getAllUserList(getdata)
      //          .then((result) => {
      //            this.setState(
      //              {
      //                is_loaded: true,
      //              },
      //              () => {
      //                this.settoptext();
      //              },
      //            );
      //            // this.setState({ is_loaded: true });

      //            result.data.getUser.map((item, index) => {
      //              this.setState({ userId: item.id });
      //              localStorage.setItem("globaluserid", item.id);
      //              this.handleInitialprechange();
      //              this.tabRef.refs.map.saveneighbordata();
      //              this.getInitialprechange();
      //              if (
      //                localStorage.getItem("savednhclickdata") &&
      //                localStorage.getItem("savednhclickdata") !== null
      //              ) {
      //                this.saveNh(
      //                  "",
      //                  JSON.parse(localStorage.getItem("savednhclickdata")),
      //                  "",
      //                );
      //              }

      //              if (
      //                localStorage.getItem("savedcityclickdata") &&
      //                localStorage.getItem("savedcityclickdata") !== null
      //              ) {
      //                this.savecity(
      //                  "",
      //                  JSON.parse(localStorage.getItem("savedcityclickdata")),
      //                  "",
      //                );
      //              }
      //              if (
      //                localStorage.getItem("savedhomeclickdata") &&
      //                localStorage.getItem("savedhomeclickdata") !== null
      //              ) {
      //                this.saveHomesRight(
      //                  JSON.parse(localStorage.getItem("savedhomeclickdata")),
      //                );
      //              }
      //              if (
      //                localStorage.getItem("ispagemain") &&
      //                localStorage.getItem("ispagemain") === "true"
      //              ) {
      //                this.tabRef.refs.map.refreshMap(this.searchaddress);
      //                localStorage.setItem("ispagemain", false);
      //                const selectedrankingdata =
      //                  localStorage.getItem("selectdnhranking");
      //                if (
      //                  selectedrankingdata &&
      //                  selectedrankingdata !== "" &&
      //                  selectedrankingdata !== undefined
      //                ) {
      //                  setTimeout(() => {
      //                    this.handleRankingpagecheck();
      //                  }, 3000);
      //                }
      //              } else {
      //                if (!this.state.is_from_login) {
      //                  this.tabRef.refs.map.refreshMap();
      //                }
      //              }
      //            });
      //          })
      //          .catch((error) => {
      //            this.setState(
      //              {
      //                is_loaded: true,
      //              },
      //              () => {
      //                this.handleInitialprechange();
      //                this.getInitialprechange();
      //                this.settoptext();
      //                if (
      //                  localStorage.getItem("ispagemain") &&
      //                  localStorage.getItem("ispagemain") === "true"
      //                ) {
      //                  this.tabRef.refs.map.refreshMap(this.searchaddress);
      //                  localStorage.setItem("ispagemain", false);
      //                  const selectedrankingdata =
      //                    localStorage.getItem("selectdnhranking");
      //                  if (
      //                    selectedrankingdata &&
      //                    selectedrankingdata !== "" &&
      //                    selectedrankingdata !== undefined
      //                  ) {
      //                    setTimeout(() => {
      //                      this.handleRankingpagecheck();
      //                    }, 3000);
      //                  }
      //                } else {
      //                  if (!this.state.is_from_login) {
      //                    this.tabRef.refs.map.refreshMap();
      //                  }
      //                }
      //              },
      //            );
      //          });
      //      }
      //    } catch (err) {
      //      if (err) {
      //        this.setState(
      //          {
      //            is_loaded: true,
      //          },
      //          () => {
      //            this.settoptext();
      //            this.getInitialprechange();
      //            if (
      //              localStorage.getItem("ispagemain") &&
      //              localStorage.getItem("ispagemain") === "true"
      //            ) {
      //              this.tabRef.refs.map.refreshMap(this.searchaddress);
      //              localStorage.setItem("ispagemain", false);
      //              const selectedrankingdata =
      //                localStorage.getItem("selectdnhranking");
      //              if (
      //                selectedrankingdata &&
      //                selectedrankingdata !== "" &&
      //                selectedrankingdata !== undefined
      //              ) {
      //                setTimeout(() => {
      //                  this.handleRankingpagecheck();
      //                }, 3000);
      //              }
      //            } else {
      //              if (!this.state.is_from_login) {
      //                this.tabRef.refs.map.refreshMap();
      //              }
      //            }
      //          },
      //        );

      //        this.setState({
      //          userdetails: "",
      //          //loggedin: false
      //        });
      //      }
      //    }
      //     */

      // Initial setup complete, now handle other initialization tasks
      this.setState({
        address: this.searchaddress,
      });

      this.detectHeight();
      window.onresize = this.detectHeight;
      this.renderData(0, 1);

      // if(localStorage.objAddNeighbourSearch && localStorage.objAddNeighbourSearch !== null && localStorage.objAddNeighbourSearch !== undefined && localStorage.current === '8') {
      if (
        localStorage.objAddNeighbourSearch &&
        localStorage.objAddNeighbourSearch !== null &&
        localStorage.objAddNeighbourSearch !== undefined &&
        localStorage.current === "1"
      ) {
        this.setState({
          lhpFactor: 1,
          persSeachData: localStorage.getItem("objAddNeighbourSearch"),
          personal_txt: "Personal Score",
          personicon: "personalized-white.svg",
          metericon: "overall-grey.svg",
        });
        localStorage.setItem("current", 0);
      }

      if (
        localStorage.getItem("personal_data") &&
        localStorage.getItem("personal_data") !== null
      ) {
        this.setState({
          personal_txt: "Personal Score",
        });
      }

      // Call setInitialData immediately - no artificial delay needed
      this.setInitialData();
      let preneighbordata = JSON.parse(
        localStorage.getItem("objAddNeighbourSearch"),
      );
      if (preneighbordata && preneighbordata.findval != null) {
        this.setState({ prefindval: preneighbordata.findval });
      }
      if (localStorage.userpreemail) {
        this.setState({ preuserid: JSON.parse(localStorage.userpreemail) });
      }
    }
    // else {
    //   window.location.reload();
    // }
  }

  // New method to handle authentication and initial data loading
  processAuthenticationAndLoadData = async () => {
    try {
      const user = await getCurrentUser();
      const attributes = await fetchUserAttributes();

      const mappedUserDetails = {
        role: attributes["custom:usertype"] || null,
        id: attributes?.sub || null,
        status: attributes?.email_verified === "true" ? true : false,
        first_name: attributes["custom:firstname"] || null,
        s_id: attributes["custom:id"] || null,
        last_name: attributes["custom:lastname"] || null,
        pwd: attributes["custom:confirmpassword"] || null,
        email: attributes.email || null,
      };
      const userdetails = user ? Object.values(mappedUserDetails || {}) : [];

      localStorage.setItem("userdetails", JSON.stringify(userdetails));

      this.setState({
        userdata: userdetails,
        userdetails,
        loggedin: true,
      });

      // Your existing user list fetch
      const getdata = {
        start: 0,
        limit: 10,
        orderBy: "email",
        order: "ASC",
        fields: [{ name: "email", value: userdetails.email, operator: "=" }],
      };

      await getAllUserList(getdata)
        .then((result) => {
          this.setState(
            {
              is_loaded: true,
            },
            () => {
              this.settoptext();
            },
          );

          result.data.getUser.map((item, index) => {
            this.setState({ userId: item.id });
            localStorage.setItem("globaluserid", item.id);
            this.handleInitialprechange();
            // Ensure map is ready before calling its methods
            this.getMapRef()?.saveneighbordata();
            this.getInitialprechange();

            if (
              localStorage.getItem("savednhclickdata") &&
              localStorage.getItem("savednhclickdata") !== null
            ) {
              this.saveNh(
                "",
                JSON.parse(localStorage.getItem("savednhclickdata")),
                "",
              );
            }

            if (
              localStorage.getItem("savedcityclickdata") &&
              localStorage.getItem("savedcityclickdata") !== null
            ) {
              this.savecity(
                "",
                JSON.parse(localStorage.getItem("savedcityclickdata")),
                "",
              );
            }

            if (
              localStorage.getItem("savedhomeclickdata") &&
              localStorage.getItem("savedhomeclickdata") !== null
            ) {
              this.saveHomesRight(
                JSON.parse(localStorage.getItem("savedhomeclickdata")),
              );
            }

            if (
              localStorage.getItem("ispagemain") &&
              localStorage.getItem("ispagemain") === "true"
            ) {
              // Add delay to ensure map is initialized
              setTimeout(() => {
                this.getMapRef()?.refreshMap(this.searchaddress);
              }, 100);
              localStorage.setItem("ispagemain", false);
              const selectedrankingdata =
                localStorage.getItem("selectdnhranking");
              if (selectedrankingdata && selectedrankingdata !== "") {
                setTimeout(() => {
                  this.handleRankingpagecheck();
                }, 3000);
              }
            } else {
              if (!this.state.is_from_login) {
                // Add delay to ensure map is initialized
                setTimeout(() => {
                  this.getMapRef()?.refreshMap();
                }, 100);
              }
            }
          });
        })
        .catch((error) => {
          this.setState(
            {
              is_loaded: true,
            },
            () => {
              this.handleInitialprechange();
              this.getInitialprechange();
              this.settoptext();
              if (
                localStorage.getItem("ispagemain") &&
                localStorage.getItem("ispagemain") === "true"
              ) {
                // Add delay to ensure map is initialized
                setTimeout(() => {
                  this.getMapRef()?.refreshMap(this.searchaddress);
                }, 100);
                localStorage.setItem("ispagemain", false);
                const selectedrankingdata =
                  localStorage.getItem("selectdnhranking");
                if (selectedrankingdata && selectedrankingdata !== "") {
                  setTimeout(() => {
                    this.handleRankingpagecheck();
                  }, 3000);
                }
              } else {
                if (!this.state.is_from_login && this.state.is_loaded) {
                  // Add delay to ensure map is initialized
                  setTimeout(() => {
                    this.getMapRef()?.refreshMap();
                  }, 100);
                }
              }
            },
          );
        });
    } catch (err) {
      // Not signed in
      console.log("User not authenticated, proceeding without login");
      this.setState(
        {
          is_loaded: true,
          userdetails: "",
          loggedin: false,
        },
        () => {
          this.settoptext();
          this.getInitialprechange();
          if (
            localStorage.getItem("ispagemain") &&
            localStorage.getItem("ispagemain") === "true"
          ) {
            // Add small delay to ensure map is ready
            setTimeout(() => {
              this.getMapRef()?.refreshMap(this.searchaddress);
            }, 100);
            localStorage.setItem("ispagemain", false);
            const selectedrankingdata =
              localStorage.getItem("selectdnhranking");
            if (selectedrankingdata && selectedrankingdata !== "") {
              setTimeout(() => {
                this.handleRankingpagecheck();
              }, 3000);
            }
          } else {
            if (!this.state.is_from_login && this.state.is_loaded) {
              // Add small delay to ensure map is ready
              setTimeout(() => {
                this.getMapRef()?.refreshMap();
              }, 100);
            }
          }
        },
      );
    }
  };

  setInitialData = () => {
    let logindata = JSON.parse(localStorage.getItem("auth_query"));

    // if(localStorage.getItem("ispagemain") === "true"){
    //   this.tabRef.refs.map.refreshMap(this.searchaddress);
    //   localStorage.setItem('ispagemain',false);
    // }
    // else if(localStorage.getItem("ispagepreserach") === "true"){
    //   this.tabRef.refs.map.refreshMap(this.searchaddress);
    //   localStorage.setItem('ispagepreserach',false);

    // }else{
    // if(localStorage.getItem("searchlatuser") === null && localStorage.getItem("searchlanguser") === null && this.searchaddress != null && localStorage.getItem("searchlat") === null){
    //   if(this.tabRef.refs != undefined){
    //   this.tabRef.refs.map.refreshMap(this.searchaddress);
    //   }else{
    //     this.setState({lat:37.773972})
    //     this.setState({lng: -122.431297})
    //     this.setState({zoom:14})
    //   }
    // }else{

    //if(this.searchaddress === null){
    if (
      localStorage.getItem("ispagemain") &&
      localStorage.getItem("ispagemain") === "false"
    ) {
      if (logindata === "" || logindata === null) {
        if (
          localStorage.getItem("searchlatuser") != null &&
          localStorage.getItem("searchlanguser") != null
        ) {
          if (
            localStorage.getItem("searchlatuser") != "" &&
            localStorage.getItem("searchlanguser") != ""
          ) {
            let lastlat = localStorage.getItem("searchlatuser");
            let lastlang = localStorage.getItem("searchlanguser");
            let lastzoom = localStorage.getItem("searchzoomuser");

            // lastlat.toFixed(6);
            // lastlang.toFixed(6);

            this.setState({ lat: Number(lastlat) });
            this.setState({ lng: Number(lastlang) });
            this.setState({ zoom: Number(lastzoom) });
          } else {
            this.setState({ zoom: 11 });

            if (!this.state.isMobile) {
              this.setState({ lat: 37.63394653644841 });
              this.setState({ lng: -122.24727600390625 });
            } else {
              this.setState({ lat: 37.634490308266784 });
              this.setState({ lng: -122.42511719042969 });
            }
          }
        } else {
          if (!this.state.isMobile) {
            this.setState({ lat: 37.63394653644841 });
            this.setState({ lng: -122.24727600390625 });
          } else {
            this.setState({ lat: 37.634490308266784 });
            this.setState({ lng: -122.42511719042969 });
          }
          this.setState({ zoom: 11 });
        }

        // }else if(logindata && localStorage.getItem("searchlat") && localStorage.getItem("searchlang") && localStorage.getItem("logoutuser") === logindata.email){
        //   let lastlat = localStorage.getItem("searchlat");
        //   let lastlang = localStorage.getItem("searchlang");
        //   let lastzoom = localStorage.getItem("searchzoom");
        //   // lastlat.toFixed(6);
        //   // lastlang.toFixed(6);
        // this.setState({lat:Number(lastlat)})
        // this.setState({lng: Number(lastlang)})
        // this.setState({zoom:Number(lastzoom)})
        // }
        // }else if(logindata && localStorage.getItem("searchlat") && localStorage.getItem("searchlang")) {
        //   let lastlat = localStorage.getItem("searchlat");
        //   let lastlang = localStorage.getItem("searchlang");
        //   let lastzoom = localStorage.getItem("searchzoom");
        //   // lastlat.toFixed(6);
        //   // lastlang.toFixed(6);
        // this.setState({lat:Number(lastlat)})
        // this.setState({lng: Number(lastlang)})
        // this.setState({zoom:Number(lastzoom)})
      } else if (
        logindata &&
        localStorage.getItem("searchlatuser") &&
        localStorage.getItem("searchlanguser")
      ) {
        let lastlat = localStorage.getItem("searchlatuser");
        let lastlang = localStorage.getItem("searchlanguser");
        let lastzoom = localStorage.getItem("searchzoomuser");
        // lastlat.toFixed(6);
        // lastlang.toFixed(6);
        this.setState({ lat: Number(lastlat) });
        this.setState({ lng: Number(lastlang) });
        this.setState({ zoom: Number(lastzoom) });
      } else {
        if (!this.state.isMobile) {
          this.setState({ lat: 37.63394653644841 });
          this.setState({ lng: -122.24727600390625 });
        } else {
          this.setState({ lat: 37.634490308266784 });
          this.setState({ lng: -122.42511719042969 });
        }
        this.setState({ zoom: 11 });
      }
    } else if (
      localStorage.getItem("ispagemain") === undefined ||
      localStorage.getItem("ispagemain") === null
    ) {
      if (
        localStorage.getItem("searchlatuser") &&
        localStorage.getItem("searchlanguser")
      ) {
        let lastlat = localStorage.getItem("searchlatuser");
        let lastlang = localStorage.getItem("searchlanguser");
        let lastzoom = localStorage.getItem("searchzoomuser");
        // lastlat.toFixed(6);
        // lastlang.toFixed(6);
        this.setState({ lat: Number(lastlat) });
        this.setState({ lng: Number(lastlang) });
        this.setState({ zoom: Number(lastzoom) });
      } else {
        if (!this.state.isMobile) {
          this.setState({ lat: 37.63394653644841 });
          this.setState({ lng: -122.24727600390625 });
        } else {
          this.setState({ lat: 37.634490308266784 });
          this.setState({ lng: -122.42511719042969 });
        }
        this.setState({ zoom: 11 });
      }
    } else {
      if (!this.state.isMobile) {
        this.setState({ lat: 37.63394653644841 });
        this.setState({ lng: -122.24727600390625 });
      } else {
        this.setState({ lat: 37.634490308266784 });
        this.setState({ lng: -122.42511719042969 });
      }
      this.setState({ zoom: 11 });
    }
  };
  settoptext = () => {
    this.setState({ is_dispaly_top_text: true });
    let menu_item_first = document.getElementById("menu_item_first");
    let menu_item_sec = document.getElementById("menu_item_sec");
    let menu_item_third = document.getElementById("menu_item_third");
    let menu_item_forth = document.getElementById("menu_item_forth");
    let menu_item_fifth = document.getElementById("menu_item_fifth");
    let menu_item_six = document.getElementById("menu_item_six");
    let menu_item_seven = document.getElementById("menu_item_seven");
    let menu_item_eight = document.getElementById("menu_item_eight");

    if (menu_item_first && menu_item_first !== null) {
      this.setState({
        top_first_sec:
          menu_item_first.offsetWidth +
          (this.state.isMobile || this.state.isTablet
            ? 0
            : menu_item_sec.offsetWidth) +
          7 +
          "px",
      });
      this.setState({
        top_second_sec:
          menu_item_third.offsetWidth +
          menu_item_forth.offsetWidth +
          menu_item_fifth.offsetWidth +
          11 +
          "px",
      });
      if (this.state.isTab && !this.state.isMobile && !this.state.isTablet) {
        this.setState({
          top_third_sec:
            menu_item_six.offsetWidth +
            menu_item_seven.offsetWidth +
            menu_item_eight.offsetWidth +
            16 +
            "px",
        });
      } else {
        this.setState({
          top_third_sec:
            menu_item_six.offsetWidth +
            menu_item_seven.offsetWidth +
            menu_item_eight.offsetWidth +
            1 +
            "px",
        });
      }
    }
  };
  scrollRight = () => {
    this.setState({ visibleSet: 2 });
    let menu = document.querySelector(".top_left_panes .ui.menu");

    if (this.state.isMobile || this.state.isTablet) {
      if (menu) {
        menu.style.setProperty("display", "flex", "important");
        menu.style.setProperty("justify-content", "start", "important");
      }
    }
    // document.getElementsByClassName("menu-item-selection")[0].scrollLeft += 500;
    document.getElementsByClassName("scroll-to-right")[0].style.visibility =
      "hidden";
    document.getElementsByClassName("scroll-to-left")[0].style.visibility =
      "visible";
    // document.getElementsByClassName("top_main")[0].scrollLeft += 100;
  };
  scrollLeft = () => {
    this.setState({ visibleSet: 1 });
    let menu = document.querySelector(".top_left_panes .ui.menu");
    // document.getElementsByClassName("menu-item-selection")[0].scrollLeft -= 500;
    if (this.state.isMobile || this.state.isTablet) {
      if (menu) {
        menu.style.setProperty("display", "flex", "important");
        menu.style.setProperty("justify-content", "center", "important");
      }
    }

    document.getElementsByClassName("scroll-to-left")[0].style.visibility =
      "hidden";
    document.getElementsByClassName("scroll-to-right")[0].style.visibility =
      "visible";
  };
  getInitialprechange = () => {
    if (this.state.userId) {
      const getdatanew = {
        start: 0,
        limit: 1,
        orderBy: this.state.userId,
        order: "ASC",
        fields: [
          {
            name: "userId",
            value: this.state.userId,
            operator: "=",
          },
        ],
      };

      getNeighborSearch(getdatanew)
        .then((result) => {
          this.setState({ personalize_data: result.data.getneighborsearch });
          result.data.getneighborsearch &&
            result.data.getneighborsearch.length > 0 &&
            result.data.getneighborsearch.map((item, index) => {
              this.setState({
                schoolbar_val: item.schoolScore,
                townbar_val: item.towncenter,
                crimebar_val: item.crimeRate,
                walkbar_val: item.walkability,
                commbar_val: item.publicspaces,
                curbbar_val: item.curbAppeal,
                valuebar_val: item.valueIndex,
                pricemin_val: item.pricemin,
                pricemax_val: item.pricemax,
              });
              const per_data = {
                userId: this.state.userId,
                schoolScore: item.schoolScore,
                crimeRate: item.crimeRate,
                walkability: item.walkability,
                towncenter: item.towncenter,
                curbAppeal: item.curbAppeal,
                publicspaces: item.publicspaces,
                valueIndex: item.valueIndex,
                pricemax: item.pricemax,
                pricemin: item.pricemin,
              };
              localStorage.setItem("personal_data", JSON.stringify(per_data));
              this.setState({ is_personalize: true });
              this.setState({ personal_txt: "Personal Score" });
              this.setState({ is_from_personal: true });
              localStorage.setItem("is_fill_personalize", true);
              let personaldata = [];
              const inititalpersonaldata = JSON.parse(
                localStorage.getItem("personal_data"),
              );
              personaldata.push(inititalpersonaldata);
              this.setState({ personalize_data: personaldata });

              if (this.state.is_from_login) {
                this.getMapRef()?.lhpTabChange("personal_right");
              }
            });
          if (
            result.data.getneighborsearch &&
            result.data.getneighborsearch.length === 0
          ) {
            let personaldata = [];
            if (
              localStorage.getItem("personal_data") &&
              localStorage.getItem("personal_data") !== ""
            ) {
              const local_personaldata = JSON.parse(
                localStorage.getItem("personal_data"),
              );
              personaldata.push(local_personaldata);
              this.setState({ personalize_data: personaldata });
              this.setState({
                schoolbar_val: local_personaldata.schoolScore,
                townbar_val: local_personaldata.towncenter,
                crimebar_val: local_personaldata.crimeRate,
                walkbar_val: local_personaldata.walkability,
                commbar_val: local_personaldata.publicspaces,
                curbbar_val: local_personaldata.curbAppeal,
                valuebar_val: local_personaldata.valueIndex,
                pricemin_val: local_personaldata.pricemin,
                pricemax_val: local_personaldata.pricemax,
                //mindisplay:true,
                //redirectval:prevData.findval
              });
            }
          }
          // if (
          //   result.data.getneighborsearch &&
          //   result.data.getneighborsearch.length === 0
          // ) {
          //   this.setState({
          //     schoolbar_val: this.state.schoolbar_val,
          //     townbar_val: this.state.townbar_val,
          //     crimebar_val: this.state.crimebar_val,
          //     walkbar_val: this.state.walkbar_val,
          //     commbar_val: this.state.commbar_val,
          //     curbbar_val: this.state.curbbar_val,
          //     valuebar_val: this.state.valuebar_val,
          //     pricemin_val: this.state.pricemin_val,
          //     pricemax_val: this.state.pricemax_val,
          //     //mindisplay:true,
          //     //redirectval:prevData.findval
          //   });
          //   this.setState({ is_personalize: true });
          //   this.setState({ personal_txt: "Personalize" });
          //   const per_data = {
          //     userId: this.state.userId,
          //     schoolScore: this.state.schoolbar_val,
          //     crimeRate: this.state.crimebar_val,
          //     walkability: this.state.walkbar_val,
          //     towncenter: this.state.townbar_val,
          //     curbAppeal: this.state.curbbar_val,
          //     community: this.state.commbar_val,
          //     valueIndex: this.state.valuebar_val,
          //     pricemax: this.state.pricemax_val,
          //     pricemin: this.state.pricemin_val,
          //   };
          //   localStorage.setItem("personal_data", JSON.stringify(per_data));
          // }
        })
        .catch((error) => { });
    } else {
      let personaldata = [];
      if (
        localStorage.getItem("personal_data") &&
        localStorage.getItem("personal_data") !== ""
      ) {
        const local_personaldata = JSON.parse(
          localStorage.getItem("personal_data"),
        );
        personaldata.push(local_personaldata);
        this.setState({ personalize_data: personaldata });
        this.setState({
          schoolbar_val: local_personaldata.schoolScore,
          townbar_val: local_personaldata.towncenter,
          crimebar_val: local_personaldata.crimeRate,
          walkbar_val: local_personaldata.walkability,
          commbar_val: local_personaldata.publicspaces,
          curbbar_val: local_personaldata.curbAppeal,
          valuebar_val: local_personaldata.valueIndex,
          pricemin_val: local_personaldata.pricemin,
          pricemax_val: local_personaldata.pricemax,
          //mindisplay:true,
          //redirectval:prevData.findval
        });
        // const per_data = {
        //   userId: local_personaldata.userId,
        //   schoolScore: local_personaldata.schoolScore,
        //   crimeRate: local_personaldata.crimeRate,
        //   walkability: local_personaldata.walkability,
        //   towncenter: local_personaldata.towncenter,
        //   curbAppeal: local_personaldata.curbAppeal,
        //   community: local_personaldata.community,
        //   valueIndex: local_personaldata.valueIndex,
        //   pricemax: local_personaldata.pricemax,
        //   pricemin: local_personaldata.pricemin,
        // };
        // localStorage.setItem("personal_data", JSON.stringify(per_data));
      }
      // this.setState({
      //   schoolbar_val: this.state.schoolbar_val,
      //   townbar_val: this.state.townbar_val,
      //   crimebar_val: this.state.crimebar_val,
      //   walkbar_val: this.state.walkbar_val,
      //   commbar_val: this.state.commbar_val,
      //   curbbar_val: this.state.curbbar_val,
      //   valuebar_val: this.state.valuebar_val,
      //   pricemin_val: this.state.pricemin_val,
      //   pricemax_val: this.state.pricemax_val,
      //   //mindisplay:true,
      //   //redirectval:prevData.findval
      // });
      // this.setState({ is_personalize: true });
      // this.setState({ personal_txt: "Personalize" });
      // const per_data = {
      //   userId: this.state.userId,
      //   schoolScore: this.state.schoolbar_val,
      //   crimeRate: this.state.crimebar_val,
      //   walkability: this.state.walkbar_val,
      //   towncenter: this.state.townbar_val,
      //   curbAppeal: this.state.curbbar_val,
      //   community: this.state.commbar_val,
      //   valueIndex: this.state.valuebar_val,
      //   pricemax: this.state.pricemax_val,
      //   pricemin: this.state.pricemin_val,
      // };
      // localStorage.setItem("personal_data", JSON.stringify(per_data));
    }
    if (
      localStorage.getItem("is_from_save") &&
      localStorage.getItem("is_from_save") !== "" &&
      localStorage.getItem("is_from_save") !== undefined
    ) {
      if (localStorage.getItem("is_from_save") === "Y") {
        this.setState({
          lhpFactor: 1,
          // persSeachData: localStorage.getItem("local_personaldata"),
          personal_txt: "Personal Score",
          personicon: "personalized-white.svg",
          metericon: "overall-grey.svg",
        });
        this.addpersoanldata();
        this.getMapRef()?.lhpTabChange("personal_right");
      }
      localStorage.setItem("is_from_save", "");
    }
    // setTimeout(() => {
    //   this.handleRankingpagecheck();
    // }, 3000);
  };

  handleRankingpagecheck = () => {
    const selectedrankingdata = localStorage.getItem("selectdnhranking");
    if (
      selectedrankingdata &&
      selectedrankingdata !== "" &&
      selectedrankingdata !== undefined
    ) {
      // if (selectedrankingdata != "npi") {
      //   this.setState({
      //     metericon: "overall-grey.svg",
      //   });
      // }
      if (selectedrankingdata === "school") {
        this.setState({
          lhpFactor: 2,
          schoolicon: "school-white.svg",
          metericon: "overall-grey.svg",
        });
        this.getMapRef()?.lhpTabChange(2);
      } else if (selectedrankingdata === "school") {
        this.setState({
          lhpFactor: 2,
          schoolicon: "school-white.svg",
          metericon: "overall-grey.svg",
        });
        this.getMapRef()?.lhpTabChange(2);
      } else if (selectedrankingdata === "crime") {
        this.setState({
          lhpFactor: 3,
          shieldicon: "safety-white.svg",
          metericon: "overall-grey.svg",
        });
        this.getMapRef()?.lhpTabChange(3);
      } else if (selectedrankingdata === "amenities") {
        this.setState({
          lhpFactor: 4,
          buildingicon: "amenities-white.svg",
          metericon: "overall-grey.svg",
        });
        this.getMapRef()?.lhpTabChange(4);
      } else if (selectedrankingdata === "medianprice") {
        this.setState({
          lhpFactor: 5,
          home_moneyicon: "price-white.svg",
          metericon: "overall-grey.svg",
        });
        this.getMapRef()?.lhpTabChange(5);
      } else if (selectedrankingdata === "value") {
        this.setState({
          lhpFactor: 6,
          walkingicon: "undervalued-white.svg",
          metericon: "overall-grey.svg",
        });
        this.getMapRef()?.lhpTabChange(6);
      } else if (selectedrankingdata === "appreciation") {
        this.setState({
          lhpFactor: 7,
          treeicon: "appreciation-white.svg",
          metericon: "overall-grey.svg",
        });
        this.getMapRef()?.lhpTabChange(7);
      }
      localStorage.removeItem("selectdnhranking");
    }
  };

  handleInitialprechange = () => {
    let personaldata = [];
    if (
      localStorage.getItem("is_from_preserach") &&
      JSON.parse(localStorage.getItem("is_from_preserach")) === true &&
      localStorage.getItem("is_from_preserach") != undefined
    ) {
      let userDetails = localStorage.getItem("userdetails");
      let userData;
      if (userDetails) {
        userData = JSON.parse(userDetails);
      }
      if (
        localStorage.getItem("personal_data") &&
        localStorage.getItem("personal_data") !== "" &&
        localStorage.getItem("personal_data") !== undefined
      ) {
        const local_personaldata = JSON.parse(
          localStorage.getItem("personal_data"),
        );
        personaldata.push(local_personaldata);
        this.setState({ personalize_data: personaldata });
        this.setState({
          schoolbar_val: local_personaldata.schoolScore,
          townbar_val: local_personaldata.towncenter,
          crimebar_val: local_personaldata.crimeRate,
          walkbar_val: local_personaldata.walkability,
          commbar_val: local_personaldata.publicspaces,
          curbbar_val: local_personaldata.curbAppeal,
          valuebar_val: local_personaldata.valueIndex,
          pricemin_val: local_personaldata.pricemin,
          pricemax_val: local_personaldata.pricemax,
          //mindisplay:true,
          //redirectval:prevData.findval
        });
        this.setState({ personal_txt: "Personal Score" });
        this.setState({ personicon: "personalized-white.svg" });
        this.getMapRef()?.lhpTabChange("personal_right");
        // this.getMapRef()?.refreshMap();
        this.setState({ lhpFactor: 1 });
      } else {
        this.setState({ personal_txt: "Personalize Search" });
        this.setState({ personicon: "personalized-white.svg" });
        this.setState({ lhpFactor: 1 });
      }
      this.setState({ metericon: "overall-grey.svg" });
      this.setState({ shieldicon: "safety-grey.svg" });
      this.setState({ walkingicon: "undervalued-grey.svg" });
      this.setState({ buildingicon: "amenities-grey.svg" });
      this.setState({ treeicon: "appreciation-grey.svg" });
      this.setState({ peopleicon: "people.svg" });
      this.setState({ home_moneyicon: "price-grey.svg" });
      this.setState({ schoolicon: "school-grey.svg" });
      localStorage.setItem("is_from_preserach", false);
    }
  };

  changeZoom = (mapzoom) => {
    this.setState({ zoom: mapzoom });
  };

  // // --- Old method checkUser ---
  // checkUser = () => {
  //   Auth.currentAuthenticatedUser({
  //     bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
  //   })
  //     .then((user) => {
  //       const userdetails = Object.values(user.attributes);
  //       if (userdetails[2] === true) {
  //         if (
  //           localStorage.objAddNeighbourSearch === "" ||
  //           localStorage.objAddNeighbourSearch === null ||
  //           localStorage.objAddNeighbourSearch === undefined
  //         ) {
  //           //Router.push('/PersSearch');
  //         } else {
  //           if (this.state.personal_txt === "Personalize Search") {
  //             //Router.push('/PersSearch');
  //           }
  //           this.setState(
  //             {
  //               lhpFactor: 1,
  //               //personal_txt: "Personal"
  //             },
  //             () => {}
  //           );
  //           this.renderData(1, this.state.rhpFactor);
  //           this.tabRef.refs.map.lhpTabChange(this.state.address);
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       if (this.state.personal_txt === "Personalize Search") {
  //         this.setState({ lhpFactor: 1 });
  //         this.setState({ personicon: "personalized-white.svg" });
  //         this.setState({ metericon: "overall-grey.svg" });
  //         this.setState({ shieldicon: "safety-grey.svg" });
  //         this.setState({ walkingicon: "undervalued-grey.svg" });
  //         this.setState({ buildingicon: "amenities-grey.svg" });
  //         this.setState({ treeicon: "appreciation-grey.svg" });
  //         this.setState({ peopleicon: "people.svg" });
  //         this.setState({ home_moneyicon: "price-grey.svg" });
  //         this.setState({ schoolicon: "school-grey.svg" });
  //         this.setState({ sactive: "" });
  //         this.setState({ amenitiesactive: "" });
  //         this.setState({ priceactive: "" });
  //       }
  //       this.setState({
  //         loggedin: false,
  //         smodal: true,
  //       });
  //       localStorage.setItem("previous_url", window.location.href);
  //       document.getElementById("sign_up_btn").click();
  //     });
  // };

  checkUser = async () => {
    try {
      // ✅ Get the current user (throws if not logged in)
      const user = await getCurrentUser();

      // ✅ Fetch session details (gives tokens, identity info)
      const session = await fetchAuthSession();

      // You can still access attributes from `idToken.payload`
      const userdetails = user?.signInDetails || {};
      // adjust depending on which user field you actually need

      // Example: If you stored a "isVerified" claim in Cognito attributes
      const isVerified = session?.tokens?.idToken?.payload?.email_verified;

      if (isVerified) {
        if (
          !localStorage.objAddNeighbourSearch ||
          localStorage.objAddNeighbourSearch === ""
        ) {
          // Router.push('/PersSearch');
        } else {
          if (this.state.personal_txt === "Personalize Search") {
            // Router.push('/PersSearch');
          }
          this.setState(
            {
              lhpFactor: 1,
              // personal_txt: "Personal"
            },
            () => { },
          );
          this.renderData(1, this.state.rhpFactor);
          this.getMapRef()?.lhpTabChange(this.state.address);
        }
      }
    } catch (err) {
      // User not authenticated
      if (this.state.personal_txt === "Personalize Search") {
        this.setState({ lhpFactor: 1 });
        this.setState({ personicon: "personalized-white.svg" });
        this.setState({ metericon: "overall-grey.svg" });
        this.setState({ shieldicon: "safety-grey.svg" });
        this.setState({ walkingicon: "undervalued-grey.svg" });
        this.setState({ buildingicon: "amenities-grey.svg" });
        this.setState({ treeicon: "appreciation-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ home_moneyicon: "price-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
        this.setState({ sactive: "" });
        this.setState({ amenitiesactive: "" });
        this.setState({ priceactive: "" });
      }
      this.setState({
        loggedin: false,
        smodal: true,
      });
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };

  handleCityHoverRight = (cityname, statename) => {
    this.getMapRef()?.check_city_hover(cityname, statename);
  };
  handleCityUnHoverRight = () => {
    this.getMapRef()?.check_city_unhover();
  };
  handleCityClick = (cityname, statename, cityfullname) => {
    this.getMapRef()?.check_city_click(
      cityname,
      statename,
      cityfullname,
      "click",
    );
  };

  handleHoverRight = (nhid) => {
    // this.setState({ unhoverd: false });
    // this.setState({ hoverdnhid: nhid });
    this.getMapRef()?.check_hover(nhid);
  };
  handleClickRight = (nhid, cat, name) => {
    this.getMapRef()?.check_click(nhid, cat, name);
  };
  handleUnhoverRight = () => {
    // this.setState({ unhoverd: true });
    this.getMapRef()?.check_hover("");
  };
  handleHomesHoverRight = (homeid) => {
    this.getMapRef()?.check_home_hover(homeid);
  };
  handleHomesUnhoverRight = (homeid) => {
    this.getMapRef()?.check_home_unhover(homeid);
  };
  handlecheckpersonal = () => {
    this.setState({ lhpFactor: 1 });
    let data = localStorage.getItem("objPersonalSearch");
    let userDetails = localStorage.getItem("userdetails");
    let userData;
    if (userDetails) {
      userData = JSON.parse(userDetails);
    }
    if (
      this.state.personalize_data &&
      this.state.personalize_data.length > 0 &&
      userDetails &&
      userDetails != null
    ) {
      this.setState({ personal_txt: "Personal Score" });
      this.setState({ personicon: "personalized-white.svg" });
      // this.tabRef.refs.map.lhpTabChange("personal_right");
      // this.setState({lhpFactor: 8});
    } else {
      this.setState({ personal_txt: "Personalize Search" });
      this.setState({ personicon: "personalized-white.svg" });
    }

    this.setState({ metericon: "overall-grey.svg" });
    this.setState({ shieldicon: "safety-grey.svg" });
    this.setState({ walkingicon: "undervalued-grey.svg" });
    this.setState({ buildingicon: "amenities-grey.svg" });
    this.setState({ treeicon: "appreciation-grey.svg" });
    this.setState({ peopleicon: "people.svg" });
    this.setState({ home_moneyicon: "price-grey.svg" });
    this.setState({ schoolicon: "school-grey.svg" });
    this.setState({ sactive: "" });
    this.setState({ amenitiesactive: "" });
    this.setState({ priceactive: "" });
  };
  checkschool = (checkschool) => {
    this.setState({ personicon: "personalized-grey.svg" });
    this.setState({ metericon: "overall-grey.svg" });
    this.setState({ shieldicon: "safety-grey.svg" });
    this.setState({ walkingicon: "undervalued-grey.svg" });
    this.setState({ buildingicon: "amenities-grey.svg" });
    this.setState({ treeicon: "appreciation-grey.svg" });
    this.setState({ peopleicon: "people.svg" });
    this.setState({ home_moneyicon: "price-grey.svg" });
    this.setState({ schoolicon: "school-white.svg" });
    //this.setState({ sactive: "" });
    this.setState({ amenitiesactive: "" });
    this.setState({ priceactive: "" });
    this.setState({ schooltxt: "School" });
    let schoolselect = 2;
    let selectschooltxt = "School";

    if (checkschool === "Primary") {
      schoolselect = 9;
      selectschooltxt = "Elementary";
      this.setState({ schooltxt: "Elementary" });
      //this.setState({eletxt:"School"});
      this.setState({ middletxt: "Middle" });
      this.setState({ hightxt: "High" });
      this.setState({ allschooltxt: "All Schools" });
      this.setState({ sactive: "active" });
    } else if (checkschool === "Middle") {
      schoolselect = 10;
      selectschooltxt = "Middle";
      this.setState({ schooltxt: "Middle" });
      this.setState({ eletxt: "Elementary" });
      //this.setState({middletxt:"School"});
      this.setState({ allschooltxt: "All Schools" });
      this.setState({ hightxt: "High" });
      this.setState({ sactive: "active" });
    } else if (checkschool === "High") {
      schoolselect = 11;
      selectschooltxt = "High";
      this.setState({ schooltxt: "High" });
      this.setState({ eletxt: "Elementary" });
      this.setState({ middletxt: "Middle" });
      //this.setState({hightxt:"School"});
      this.setState({ allschooltxt: "All Schools" });
      this.setState({ sactive: "active" });
    } else {
      schoolselect = 2;
      selectschooltxt = "School";
    }

    this.schooltext = selectschooltxt;
    this.setState({ lhpFactor: schoolselect });
    this.getMapRef()?.lhpTabChange(schoolselect);
  }

  checkUsergo = () => {
    this.setState({ is_edit_click: false });
    if (
      localStorage.getItem("is_from_cityclick") &&
      localStorage.getItem("is_from_cityclick") !== undefined &&
      localStorage.getItem("is_from_cityclick") !== ""
    ) {
      this.setState({ rhpFactor: 0 });
      localStorage.setItem("is_from_cityclick", "");
    }
    this.setState({ lhpFactor: 1 });
    this.renderData(1, this.state.rhpFactor);
    if (this.state.singleneighbordata.length > 0) {
      this.getMapRef()?.handleselectednhchange(
        this.state.singleneighbordata,
      );
    }
    this.getMapRef()?.lhpTabChange("personal_right");

    this.setState({ previous_active: "Personal" });
    this.setState({ personal_txt: "Personal Score" });
    this.setState({ personicon: "personalized-white.svg" });
    this.setState({ metericon: "overall-grey.svg" });
    this.setState({ shieldicon: "safety-grey.svg" });
    this.setState({ walkingicon: "undervalued-grey.svg" });
    this.setState({ buildingicon: "amenities-grey.svg" });
    this.setState({ treeicon: "appreciation-grey.svg" });
    this.setState({ peopleicon: "people.svg" });
    this.setState({ home_moneyicon: "price-grey.svg" });
    this.setState({ schoolicon: "school-grey.svg" });
    this.setState({ sactive: "" });
    this.setState({ amenitiesactive: "" });
    this.setState({ priceactive: "" });
    let rangebardata = [];
    let selectedpersonaldata = {
      schoolScore: this.state.schoolbar_val,
      crimeRate: this.state.crimebar_val,
      towncenter: this.state.townbar_val,
      curbAppeal: this.state.curbbar_val,
      walkability: this.state.walkbar_val,
      publicspaces: this.state.commbar_val,
      valueIndex: this.state.valuebar_val,
      pricemax: this.state.pricemax_val,
      pricemin: this.state.pricemin_val,
    };
    rangebardata.push(selectedpersonaldata);
    this.setState({ selectedpersonaldata: rangebardata });
    this.setState({ personalize_data: rangebardata });
    this.setState({ is_edit_click: false });
    // Auth.currentAuthenticatedUser({
    //   bypassCache: true // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    // })
    //   .then(user => {
    //     const userdetails = Object.values(user.attributes);
    //     if (userdetails[2] === true) {
    //       if (
    //         localStorage.objAddNeighbourSearch === '' ||
    //         localStorage.objAddNeighbourSearch === null ||
    //         localStorage.objAddNeighbourSearch === undefined
    //       ) {
    //         //Router.push('/PersSearch');
    //       } else {
    //        //Router.push('/PersSearch');
    //         this.setState(
    //           {
    //             lhpFactor: 8,
    //             //personal_txt: "Personal"
    //           },
    //           () => {}
    //         );
    //         this.renderData(1, this.state.rhpFactor);
    //         this.tabRef.refs.map.lhpTabChange(this.state.address);
    //       }
    //     }
    //   })
    //   .catch(err => {
    //     this.setState({
    //       loggedin: false,
    //       smodal: true
    //     });
    //   });
  };

  detectHeight = () => {
    this.setState({
      height: window.innerHeight - 197,
      mapHeight:
        window.innerWidth <= 767
          ? window.innerHeight - 95
          : window.innerHeight - 105,
    });
  }

  handleInputChange = (event) => {
    this.setState({ zoom: 14 });
    this.setState({ rhpFactor: event });
    if (this.homesRef?.current?.setsavedData) {
      this.homesRef.current.setsavedData(this.state.savedhomedata);
    }
    //cookie.remove('map-cookie');
    this.renderData(this.state.lhpFactor, event);
  }

  handleAddressChange = (address) => {
    //cookie.remove('map-cookie');
    // this.setState({zoom: 12})
    this.setState({ address: address });
  };

  handleSelects = (address) => {
    Router.push("/?address=" + address);
    this.getMapRef()?.refreshMap(address);
  }

  handleTabscroll = (e) => {
    if (this._preventEvent) {
      this._preventEvent = false;
      return;
    }
    this._preventEvent = true;
    this.contentScroll.current.scrollLeft = e.target.scrollLeft;
  };
  handleChange = (value, data) => {
    if (
      data &&
      (data.activeIndex === 2 ||
        data.activeIndex === 8 ||
        data.activeIndex === 9 ||
        data.activeIndex === 10 ||
        data.activeIndex === 11)
    ) {
      this.setState({ sactive: "active" });
      this.setState({ amenitiesactive: "" });
      this.setState({ priceactive: "" });
    } else {
      this.setState({ sactive: "" });
    }
    if (data && data.activeIndex === 1) {
      let personaldata = [];

      this.setState({ lhpFactor: data.activeIndex });
      //this.checkUser();
      // let data_pre = localStorage.getItem('objPersonalSearch');
      let userDetails = localStorage.getItem("userdetails");
      let userData;
      if (userDetails) {
        userData = JSON.parse(userDetails);
      }

      if (
        this.state.personalize_data &&
        this.state.personalize_data.length > 0 &&
        userDetails &&
        userDetails != null
      ) {
        if (this.state.personal_txt !== "Personalize Search") {
          this.getMapRef()?.lhpTabChange("personal_right");
        }
      } else if (
        localStorage.getItem("personal_data") &&
        localStorage.getItem("personal_data") !== "" &&
        localStorage.getItem("personal_data") !== undefined
      ) {
        const local_personaldata = JSON.parse(
          localStorage.getItem("personal_data"),
        );
        personaldata.push(local_personaldata);
        this.setState({ personalize_data: personaldata });
        this.setState({
          schoolbar_val: local_personaldata.schoolScore,
          townbar_val: local_personaldata.towncenter,
          crimebar_val: local_personaldata.crimeRate,
          walkbar_val: local_personaldata.walkability,
          commbar_val: local_personaldata.publicspaces,
          curbbar_val: local_personaldata.curbAppeal,
          valuebar_val: local_personaldata.valueIndex,
          pricemin_val: local_personaldata.pricemin,
          pricemax_val: local_personaldata.pricemax,
          //mindisplay:true,
          //redirectval:prevData.findval
        });
        this.setState({ personal_txt: "Personal Score" });
        this.getMapRef()?.lhpTabChange("personal_right");
      } else {
        if (this.state.personal_txt !== "Personalize Search") {
          this.getMapRef()?.lhpTabChange("personal_right");
        } else {
          //if (this.state.personal_txt !== "Personalize") {
          this.getMapRef()?.lhpTabChange(data.activeIndex);
          //this.setState({ personal_txt: "Personal" });
          //}
        }
      }
      //Router.push('/PersSearch');
    } else if (
      this.schooltext === "Elementary" &&
      data &&
      (data.activeIndex === 2 ||
        data.activeIndex === 8 ||
        data.activeIndex === 9 ||
        data.activeIndex === 10 ||
        data.activeIndex === 11)
    ) {
      this.setState(
        {
          lhpFactor: 9,
        },
        () => {
          // this.tabRef.refs.map.refreshMap(this.state.address)
          // this.tabRef.refs.map.lhpTabChange(this.state.address)
        },
      );

      this.renderData(9, this.state.rhpFactor);
      this.getMapRef()?.lhpTabChange(this.state.address);
      this.getMapRef()?.lhpTabChange(9);
    } else if (
      this.schooltext === "Middle" &&
      data &&
      (data.activeIndex === 2 ||
        data.activeIndex === 8 ||
        data.activeIndex === 9 ||
        data.activeIndex === 10 ||
        data.activeIndex === 11)
    ) {
      this.setState(
        {
          lhpFactor: 10,
        },
        () => {
          // this.tabRef.refs.map.refreshMap(this.state.address)
          // this.tabRef.refs.map.lhpTabChange(this.state.address)
        },
      );

      this.renderData(10, this.state.rhpFactor);
      this.getMapRef()?.lhpTabChange(this.state.address);
      this.getMapRef()?.lhpTabChange(10);
    } else if (
      this.schooltext === "High" &&
      data &&
      (data.activeIndex === 2 ||
        data.activeIndex === 8 ||
        data.activeIndex === 9 ||
        data.activeIndex === 10 ||
        data.activeIndex === 11)
    ) {
      this.setState(
        {
          lhpFactor: 11,
        },
        () => {
          // this.tabRef.refs.map.refreshMap(this.state.address)
          // this.tabRef.refs.map.lhpTabChange(this.state.address)
        },
      );

      this.renderData(11, this.state.rhpFactor);
      this.getMapRef()?.lhpTabChange(this.state.address);
      this.getMapRef()?.lhpTabChange(11);
    } else if (
      this.amentiestext === "Near Merchants" &&
      data &&
      (data.activeIndex === 4 || data.activeIndex === 12)
    ) {
      this.setState({ lhpFactor: 12 });
      this.renderData(12, this.state.rhpFactor);
      this.getMapRef()?.lhpTabChange(this.state.address);
      this.getMapRef()?.lhpTabChange(12);
    } else if (
      this.amentiestext === "Public Spaces" &&
      data &&
      (data.activeIndex === 4 || data.activeIndex === 13)
    ) {
      this.setState({ lhpFactor: 13 });
      this.renderData(13, this.state.rhpFactor);
      this.getMapRef()?.lhpTabChange(this.state.address);
      this.getMapRef()?.lhpTabChange(13);
    } else if (
      this.amentiestext === "Walkable Streets" &&
      data &&
      (data.activeIndex === 4 || data.activeIndex === 14)
    ) {
      this.setState({ lhpFactor: 14 });
      this.renderData(14, this.state.rhpFactor);
      this.getMapRef()?.lhpTabChange(this.state.address);
      this.getMapRef()?.lhpTabChange(14);
    } else if (
      this.amentiestext === "Curb Appeal" &&
      data &&
      (data.activeIndex === 4 || data.activeIndex === 15)
    ) {
      this.setState({ lhpFactor: 15 });
      this.renderData(15, this.state.rhpFactor);
      this.getMapRef()?.lhpTabChange(this.state.address);
      this.getMapRef()?.lhpTabChange(15);
    } else {
      this.setState(
        {
          lhpFactor: data.activeIndex,
        },
        () => {
          // this.tabRef.refs.map.refreshMap(this.state.address)
          // this.tabRef.refs.map.lhpTabChange(this.state.address)
        },
      );

      this.renderData(data.activeIndex, this.state.rhpFactor);
      this.getMapRef()?.lhpTabChange(this.state.address);
      this.getMapRef()?.lhpTabChange(data.activeIndex);
    }
  };

  handleChangeRHP = (value, data) => {
    if (data.activeIndex === 0) {
      if (this.homesRef?.current?.setData) {
        this.homesRef.current.setData(this.state.neighborhood);
      }
    }

    if (data.activeIndex === 2) {
      if (this.homesRef?.current?.setData) {
        this.homesRef.current.setData(this.state.homedata);
      }
    }

    if (data.activeIndex === 1) {
      if (this.homesRef?.current?.setData) {
        this.homesRef.current.setData(this.state.neighborhood);
      }
      if (
        this.state.singleneighbordata &&
        this.state.singleneighbordata.length > 0
      ) {
        setTimeout(function () {
          var element = document.getElementById("single_main_top");

          if (element) {
            element.classList.add("open");

            element.scrollIntoView({
              behavior: "smooth",
            });
          }
        }, 500);
      }
    }
    this.setState({
      rhpFactor: data.activeIndex,
      selectedNeighbour: false,
    });

    this.renderData(this.state.lhpFactor, data.activeIndex);
  };

  handleChangeRHP2 = (value, data, datas, type) => {
    if (datas && datas.geoType === "listing") {
      this.setState({
        rhpFactor: data.activeIndex,
        selectedNeighbour: datas,
      });
      this.renderData(this.state.lhpFactor, data.activeIndex);
      if (
        this.state.selectedNeighbour &&
        this.state.selectedNeighbour !== null &&
        this.state.selectedNeighbour.id === datas.id
      ) {
        window.open("/DetailsListing/", "_blank");
      }
    } else if (
      this.state.selectedNeighbour &&
      this.state.selectedNeighbour !== null &&
      this.state.selectedNeighbour.name === datas.name
    ) {
      this.setState({
        rhpFactor: data.activeIndex,
        selectedNeighbour: datas,
      });
      this.renderData(this.state.lhpFactor, data.activeIndex);
      if (type === "N") {
        var win = window.open("/Neighborhood/", "_blank");
      }
    } else {
      this.setState({
        rhpFactor: data.activeIndex,
        selectedNeighbour: datas,
      });
      this.renderData(this.state.lhpFactor, data.activeIndex);
    }
  };

  selectedNeighbor = (value, data) => {
    if (data === "N") {
      this.handleChangeRHP2(
        this.state.lhpFactor,
        { activeIndex: 1 },
        value,
        data,
      );
    } else if (data === "H") {
      this.handleChangeRHP2(
        this.state.lhpFactor,
        { activeIndex: 2 },
        value,
        data,
      );
    } else {
      this.handleChangeRHP2(
        this.state.lhpFactor,
        { activeIndex: 0 },
        value,
        data,
      );
    }
  };

  filterHome = () => {
    this.setState(
      {
        rhpFactor: 2,
        filterHome: !this.state.filterHome,
      },
      function () {
        (this.setState({
          rhpFactor: 2,
        }),
          this.homesRef &&
          this.homesRef?.current &&
          this.homesRef?.current?.FilterOption &&
          this.homesRef?.current?.FilterOption(this.state.filterHome));
      },
    );
    setTimeout(() => {
      if (this.state.filterHome) {
        document.getElementById("filter_section").scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      } else {
        document.getElementById("filter_btn").scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    }, 500);
    this.renderData(this.state.lhpFactor, 2);
  };

  // // --- Old method modalSubmit ---
  // modalSubmit = (values) => {
  //   let id = values.id;
  //   // this.setState({smodal:false,lmodal:false});
  //   if (id === "lmodal") {
  //     localStorage.setItem("auth_query", JSON.stringify(values));
  //     // Router.push({pathname: '/login',asPath: '/login', query: values},'/login');
  //     const username = values.email;
  //     const password = values.password;
  //     var flag = 1;
  //     if (values && values.email === "") {
  //       flag = 0;
  //       this.setState({
  //         email_err_status: true,
  //         email_err_msg: "Email is Required",
  //       });
  //     }
  //     if (values && values.password === "") {
  //       flag = 0;
  //       this.setState({
  //         pwd_err_status: true,
  //         pwd_err_msg: "Password is Required",
  //       });
  //     }
  //     if (flag === 1) {
  //       const username = values.email;
  //       const password = values.password;
  //       const isChecked = this.state.isChecked;
  //       if (isChecked && username !== "") {
  //         localStorage.setItem("email", username);
  //         localStorage.setItem("password", password);
  //         localStorage.setItem("checkbox", isChecked);
  //       }

  //       Auth.signIn({
  //         username,
  //         password,
  //       })
  //         .then((user) => {
  //           Auth.currentAuthenticatedUser({
  //             bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
  //           }).then((user) => {
  //             const registertype = Object.values(user.attributes);
  //             if (user.attributes.email_verified === true) {
  //               this.setState({
  //                 lmodal: false,
  //                 smodal: false,
  //               });
  //               const userdetails = Object.values(user.attributes);
  //               localStorage.setItem(
  //                 "userdetails",
  //                 JSON.stringify({
  //                   role: userdetails[0],
  //                   id: userdetails[1],
  //                   status: userdetails[2],
  //                   first_name: userdetails[3],
  //                   s_id: userdetails[4],
  //                   last_name: userdetails[5],
  //                   pwd: userdetails[6],
  //                   email: userdetails[7],
  //                 })
  //               );
  //               //this.setState({ userdata: userdetails });
  //               //this.setState({saveddata: this.state.saveddata});

  //               // window.open('/PreSearch','_blank')
  //               //Router.push('/PersSearch');

  //               // if(this.state.lhpFactor === 8){
  //               //   localStorage.setItem('is_from_preserach',true);
  //               //   localStorage.setItem('is_already_perosnal',true);
  //               // }
  //               // location.reload();

  //               // if (this.state.lhpFactor === 1) {
  //               //localStorage.setItem('is_from_preserach',true);

  //               localStorage.setItem("load_header", false);

  //               let data = localStorage.getItem("objPersonalSearch");
  //               let userDetails = localStorage.getItem("userdetails");
  //               let userData;
  //               if (userDetails) {
  //                 userData = JSON.parse(userDetails);
  //               }
  //               if (this.state.lhpFactor === 1) {
  //                 this.setState({ lhpFactor: 1 });
  //                 this.setState({ metericon: "overall-grey.svg" });
  //                 this.setState({ shieldicon: "safety-grey.svg" });
  //                 this.setState({ walkingicon: "undervalued-grey.svg" });
  //                 this.setState({ buildingicon: "amenities-grey.svg" });
  //                 this.setState({ treeicon: "appreciation-grey.svg" });
  //                 this.setState({ peopleicon: "people.svg" });
  //                 this.setState({ home_moneyicon: "price-grey.svg" });
  //                 this.setState({ schoolicon: "school-grey.svg" });
  //                 this.setState({ is_from_login: true });
  //               }
  //               this.setState({ is_loading: true });
  //               // this.tabRef.refs.map.refreshMap();
  //               // this.tabRef.refs.map.componentDidMount();
  //               this.setState({ address: "" });

  //               this.componentDidMount();
  //               // }

  //               // window.location.reload(false);
  //             } else if (user.attributes.email_verified === false) {
  //               this.setState({
  //                 verifymessage: "Please verify your email first",
  //                 pwd_err_msg: "Please verify your email first",
  //               });
  //             }
  //           });
  //         })
  //         .catch((err) => {
  //           if (err) {
  //             this.setState({
  //               message: err.message,
  //               loggedin: false,
  //               pwd_err_status: true,
  //               pwd_err_msg: err.message,
  //             });
  //           }
  //         });
  //     }
  //   } else if (id === "smodal") {
  //     localStorage.setItem("previous_url", window.location.href);
  //     if (this.state.lhpFactor === 1) {
  //       localStorage.setItem("is_from_preserach", true);
  //       localStorage.setItem("is_already_perosnal", true);
  //     }
  //     localStorage.setItem("auth_query", JSON.stringify(values));
  //     Router.push(
  //       { pathname: "/RegMain", asPath: "/RegMain", query: values },
  //       "/RegMain"
  //     );
  //   }
  // };

  modalSubmit = async (values) => {
    let id = values.id;

    if (id === "lmodal") {
      localStorage.setItem("auth_query", JSON.stringify(values));
      const username = values.email;
      const password = values.password;
      let flag = 1;

      if (!username) {
        flag = 0;
        this.setState({
          email_err_status: true,
          email_err_msg: "Email is Required",
        });
      }

      if (!password) {
        flag = 0;
        this.setState({
          pwd_err_status: true,
          pwd_err_msg: "Password is Required",
        });
      }

      if (flag === 1) {
        const isChecked = this.state.isChecked;
        if (isChecked && username !== "") {
          localStorage.setItem("email", username);
          localStorage.setItem("password", password);
          localStorage.setItem("checkbox", isChecked);
        }

        try {
          await signIn({ username, password });

          const session = await fetchAuthSession();
          const claims = session?.tokens?.idToken?.payload || {};

          if (claims.email_verified === true) {
            this.setState({
              lmodal: false,
              smodal: false,
            });

            // Store user details in localStorage (adjust mapping as per your needs)
            const userdetails = {
              role: claims["custom:usertype"] || "",
              id: claims?.sub || "",
              status: claims?.email_verified === "true" ? true : false,
              first_name: claims["custom:firstname"] || "",
              s_id: claims["custom:id"] || "",
              last_name: claims["custom:lastname"] || "",
              pwd: password,
              email: claims.email,
            };

            localStorage.setItem("userdetails", JSON.stringify(userdetails));
            localStorage.setItem("load_header", false);

            if (this.state.lhpFactor === 1) {
              this.setState({
                lhpFactor: 1,
                metericon: "overall-grey.svg",
                shieldicon: "safety-grey.svg",
                walkingicon: "undervalued-grey.svg",
                buildingicon: "amenities-grey.svg",
                treeicon: "appreciation-grey.svg",
                peopleicon: "people.svg",
                home_moneyicon: "price-grey.svg",
                schoolicon: "school-grey.svg",
                is_from_login: true,
              });
            }

            this.setState({ is_loading: true, address: "" });

            // Re-run init logic
            this.componentDidMount();
          } else {
            this.setState({
              verifymessage: "Please verify your email first",
              pwd_err_msg: "Please verify your email first",
            });
          }
        } catch (err) {
          this.setState({
            message: err.message,
            loggedin: false,
            pwd_err_status: true,
            pwd_err_msg: err.message,
          });
        }
      }
    } else if (id === "smodal") {
      localStorage.setItem("previous_url", window.location.href);
      if (this.state.lhpFactor === 1) {
        localStorage.setItem("is_from_preserach", true);
        localStorage.setItem("is_already_perosnal", true);
      }
      localStorage.setItem("auth_query", JSON.stringify(values));
      Router.push(
        { pathname: "/RegMain", asPath: "/RegMain", query: values },
        "/RegMain",
      );
    }
  };

  nextModal = (e) => {
    let id = e.target.id;
    id === "smodal"
      ? this.setState({ smodal: false, lmodal: true })
      : this.setState({ smodal: true, lmodal: false });
  };

  closeModal = () => {
    this.setState({ smodal: false, lmodal: false });
    // if(this.state.lhpFactor === 1){

    // }
    // this.setState({ lhpFactor: 0 });
    // this.setState({ metericon: "overall-white.svg" });
    // this.setState({ shieldicon: "safety-grey.svg" });
    // this.setState({ walkingicon: "dom.svg" });
    // this.setState({ buildingicon: "amenities-grey.svg" });
    // this.setState({ treeicon: "appreciation-grey.svg" });
    // this.setState({ peopleicon: "people.svg" });
    // this.setState({ home_moneyicon: "price-grey.svg" });
    // this.setState({ schoolicon: "school-grey.svg" });
    // this.setState({ personicon: "personalized-grey.svg" });
    // this.setState({ sactive: "" });
  };

  renderData = (lhp, rhp) => {
    let that = this;
    if (rhp === 0) {
      let homefetch = this.state.homedata;
      let neighborfetch = this.state.neighbordata;
      this.setState({ homesdata: homefetch });
      this.setState({ neighborhood: neighborfetch });
    } else if (rhp === 1) {
      let homefetch = this.state.homedata;
      let neighborfetch = this.state.neighbordata;
      this.setState({ homesdata: homefetch });
      this.setState({ neighborhood: neighborfetch });
    } else if (rhp === 2) {
      let homefetch = this.state.homedata;
      let neighborfetch = this.state.neighbordata;
      this.setState({ homesdata: homefetch });
      this.setState({ neighborhood: neighborfetch });
    } else {
      let homefetch = this.state.homedata;
      let neighborfetch = this.state.neighbordata;
      this.setState({ homesdata: homefetch });
      this.setState({ neighborhood: neighborfetch });
    }
  }

  getdatafromhomes = (val) => {
    this.setState({ getdatafromhomes: val });
    this.getMapRef()?.getdatafromindex(val);
  };

  saveHomesRight = (item) => {
    let home_point =
      "POINT(" +
      parseFloat(item.Latitude) +
      "," +
      parseFloat(item.Longitude) +
      ")";

    const getdatanew = {
      start: 0,
      limit: 1,
      orderBy: "name",
      order: "homeinnh",
      fields: [
        {
          name: "id",
          value: home_point,
          operator: "=",
        },
      ],
    };

    getAllneighborboundrieslist(getdatanew)
      .then((result) => {
        let nhid = "";
        if (result && result.data.getneighborboundries.length > 0) {
          nhid = result.data.getneighborboundries[0].id;
        } else {
          nhid = "";
        }
        const adddata = {
          homeid: item.ListingKeyNumeric,
          userId: this.state.userId,
          address: item.UnparsedAddress,
          savedDate: new Date(),
          updatedDate: new Date(),
          savedStatus: 1,
          neighborhoodId: nhid,
        };
        addSavedhomes(adddata)
          .then((result) => {
            this.getMapRef()?.savedhomedata();
            localStorage.removeItem("savedhomeclickdata");
          })
          .catch((error) => { });
      })
      .catch((error) => { });
  };

  deletesavedright = (item) => {
    const deletedataId = {
      homeid: item.ListingKeyNumeric,
      userId: this.state.userId,
    };
    deleteSavedhomes(deletedataId)
      .then((result) => { })
      .catch((error) => { });
  };

  saveNh = (data, item, cat) => {
    let adddata = {};
    if (cat === "saved") {
      adddata = {
        userId: this.state.userId,
        neighborhoodId: item.neighborhoodId,
        name: item.name,
        city: item.city,
        state: item.state,
        savedDate: new Date(),
        updatedDate: new Date(),
        savedStatus: 1,
      };
    } else {
      adddata = {
        userId: this.state.userId,
        neighborhoodId: item.id,
        name: item.name,
        city: item.postalcity_name,
        state: item.state_name,
        savedDate: new Date(),
        updatedDate: new Date(),
        savedStatus: 1,
      };
    }

    addsavedneighborhoodbyuser(adddata)
      .then((result) => {
        this.getMapRef()?.saved_nh_boundary(adddata.neighborhoodId);
        localStorage.removeItem("savednhclickdata");

        // let { nhheart } = this.state;
        //  nhheart[data] = !nhheart[data];
        // this.setState({ nhheart });
      })
      .catch((error) => { });
  };

  getsavednhdata = (data, item, cat) => {
    let count = 1;
    this.setState({ nhsaved: this.state.nhsaved + count });
    let { loggedin } = this.state;

    if (loggedin) {
      let { nhheart } = this.state;
      nhheart[data] = !nhheart[data];
      this.setState({ nhheart });
      if (this.state.nhheart[data] === true) {
        this.saveNh(data, item, cat);
      } else {
        this.saveNh(data, item, cat);
      }
    } else {
      localStorage.setItem("savednhclickdata", JSON.stringify(item));
      this.setState({ smodal: true });
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };

  getsavedcitydata = (data, item, cat) => {
    let count = 1;
    this.setState({ nhsaved: this.state.nhsaved + count });
    let { loggedin } = this.state;

    if (loggedin) {
      let { cityheart } = this.state;

      cityheart[data] = !cityheart[data];
      this.setState({ cityheart });

      if (this.state.cityheart[data] === true) {
        this.savecity(data, item, cat);
        this.getMapRef()?.check_city_click(
          item.postalcity_name,
          item.state_name,
          "save",
        );
      } else {
        this.savecity(data, item, cat);
        this.getMapRef()?.clearsavedcitypolygon(
          item.postalcity_name,
          item.state_name,
        );
      }
    } else {
      localStorage.setItem("savedcityclickdata", JSON.stringify(item));
      this.setState({ smodal: true });
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };

  savecity = (data, item, cat) => {
    const adddata = {
      userId: this.state.userId,
      name: item.postalcity_name,
      savedDate: new Date(),
      updatedDate: new Date(),
      savedStatus: 1,
    };

    addsavedcitybyuser(adddata)
      .then((result) => {
        this.getMapRef()?.get_saved_cities();
        localStorage.removeItem("savedcityclickdata");
      })
      .catch((error) => {
        localStorage.removeItem("savedcityclickdata");
        console.error("graphql error:::", error);
      });
  };

  getsavedhomedata = (data, item) => {
    let count = 1;
    this.setState({ nhsaved: this.state.nhsaved + count });
    let { loggedin } = this.state;

    if (loggedin) {
      let { heart } = this.state;
      heart[data] = !heart[data];
      this.setState({ heart });

      if (this.state.heart[data] === true) {
        this.saveHomesRight(item);
        this.getMapRef()?.check_save_home_click(item);
      } else {
        this.deletesavedright(item);
        this.getMapRef()?.check_unsave_home_click(item);
      }
    } else {
      localStorage.setItem("savedhomeclickdata", JSON.stringify(item));
      this.setState({ smodal: true });
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };

  getrightsavedcitydata = () => {
    this.state.savedcitydata &&
      this.state.savedcitydata.length > 0 &&
      this.state.savedcitydata.map((item, index) => {
        let { cityheart } = this.state;

        cityheart[item.postalcity_name] = true;
        this.setState({ cityheart });
      });
  };

  getrightsavednhdata = () => {
    this.state.neighbordata &&
      this.state.neighbordata.length > 0 &&
      this.state.neighbordata.map((item, index) => {
        if (item.savedneighborhoodbyuser === "1") {
          let { nhheart } = this.state;
          nhheart[item.id] = true;
          this.setState({ nhheart });
        } else {
          let { nhheart } = this.state;
          nhheart[item.id] = false;
          this.setState({ nhheart });
        }
      });
  };

  getrightsavedsavenhdata = () => {
    this.state.savedneighbordata &&
      this.state.savedneighbordata.length > 0 &&
      this.state.savedneighbordata.map((item, index) => {
        if (item.neighborhoodId) {
          let { nhheart } = this.state;
          nhheart[item.id] = true;
          this.setState({ nhheart });
        } else {
          let { nhheart } = this.state;
          nhheart[item.id] = false;
          this.setState({ nhheart });
        }
      });
  };
  getrightsavedhomedata = () => {
    let { heart } = this.state;
    this.state.savedhomedata &&
      this.state.savedhomedata.map((item, index) => {
        heart[item.ListingKeyNumeric] = true;
      });
    this.setState({ heart });
    this.setState({ nhsaved: this.state.nhsaved + 1 });

    // this.state.homedata.map((item, index) => {
    //   if (!this.savedrighthome.includes(item.ListingKeyNumeric)) {
    //     this.savedrighthome.push(item.ListingKeyNumeric);
    //   }
    // });
    // const getdata = {
    //   start: 0,
    //   limit: 100,
    //   orderBy: "address",
    //   order: "ASC",
    //   fields: [
    //     {
    //       name: "homeid",
    //       value: "",
    //       operator: "!="
    //     }
    //   ]
    // };
    // getAllSavedHomelist(getdata)
    //   .then(result => {
    //     this.setState({ rightsidehome: result.data.getsavedhome });
    //     {
    //       result.data.getsavedhome.map((item, index) => {
    //         if (item.userId === this.state.userId) {
    //           if (this.savedrighthome.includes(parseInt(item.homeid.trim()))) {
    //             let { heart } = this.state;
    //             heart[item.homeid] = true;
    //             this.setState({ heart });
    //           } else {
    //             let { heart } = this.state;
    //             heart[item.homeid] = false;
    //             this.setState({ heart });
    //           }
    //         }
    //       });
    //     }
    //   })
    //   .catch(error => {
    //   });
  };

  // displayhandler = () => {
  //   let npi_tab = document.getElementById("menu_item_first");
  //   let val_tab = document.getElementById("menu_item_sec");
  //   this.setState({
  //     schoolleft: npi_tab.offsetWidth + val_tab.offsetWidth + 20 + "px",
  //   });
  //   this.setState({ tabdisplay: "block" });
  // };
  displayhandlersec = () => {
    this.setState({ tabdisplay: "none" });
  };

  displayhandlerprice = () => {
    let npi_tab = document.getElementById("menu_item_first");
    let val_tab = document.getElementById("menu_item_sec");
    let school_tab = document.getElementById("menu_item_third");
    let safety_tab = document.getElementById("menu_item_forth");
    let town_tab = document.getElementById("menu_item_fifth");

    // this.setState({
    //   priceleft:
    //     npi_tab.offsetWidth +
    //     val_tab.offsetWidth +
    //     school_tab.offsetWidth +
    //     safety_tab.offsetWidth +
    //     town_tab.offsetWidth +
    //     20 +
    //     "px",
    // });
    this.state.isMobile
      ? this.setState({
        priceleft:
          document
            .getElementsByClassName("price_cls")[0]
            .getBoundingClientRect().left +
          5 +
          "px",
      })
      : this.setState({
        priceleft:
          document
            .getElementsByClassName("price_cls")[0]
            .getBoundingClientRect().left +
          -164 +
          "px",
      });
    this.setState({ pricetabdisplay: "block" });
  };
  displayunhandlerprice = () => {
    this.setState({ pricetabdisplay: "none" });
  };
  displayhandleredit = () => {
    let personal_tab = document.getElementById("menu_item_sec");

    this.setState({
      editwidth: document.getElementsByClassName("per_search")[0].clientWidth,
    });
    this.state.isMobile || this.state.isTablet
      ? this.setState({
        editleft:
          document
            .getElementsByClassName("per_search")[0]
            .getBoundingClientRect().left -
          4 +
          "px",
      })
      : this.setState({
        editleft:
          document
            .getElementsByClassName("per_search")[0]
            .getBoundingClientRect().left +
          -25 +
          "px",
      });
    //if (this.state.personal_txt == "Personal Score") {
    this.setState({ editabdisplay: "block" });
    // }
  };
  displayunhandleredit = () => {
    this.setState({ editabdisplay: "none" });
  };
  displayhandleramenities = () => {
    let npi_tab = document.getElementById("menu_item_first");
    let val_tab = document.getElementById("menu_item_sec");
    let school_tab = document.getElementById("menu_item_third");
    let safety_tab = document.getElementById("menu_item_forth");
    this.setState({
      amenitieswidth:
        document.getElementsByClassName("amenities_main")[0].clientWidth,
    });
    this.state.isMobile || this.state.isTablet
      ? this.setState({
        amenitiesleft:
          document
            .getElementsByClassName("amenities_main")[0]
            .getBoundingClientRect().left -
          4 +
          "px",
      })
      : this.setState({
        amenitiesleft:
          document
            .getElementsByClassName("amenities_main")[0]
            .getBoundingClientRect().left +
          -25 +
          "px",
      });
    // this.setState({
    //   amenitiesleft:
    //     npi_tab.offsetWidth +
    //     val_tab.offsetWidth +
    //     school_tab.offsetWidth +
    //     safety_tab.offsetWidth +
    //     15 +
    //     "px",
    // });

    this.setState({ amenitiestabdisplay: "block" });
  };

  displayunhandleramenities = () => {
    this.setState({ amenitiestabdisplay: "none" });
  };

  displayhandler = () => {
    this.setState({ displayMapMask: true });
    let npi_tab = document.getElementById("menu_item_first");
    this.setState({
      schoolwidth: document.getElementsByClassName("value_item")[0].clientWidth,
    });
    this.state.isMobile || this.state.isTablet
      ? this.setState({
        schoolleft:
          document
            .getElementsByClassName("value_item")[0]
            .getBoundingClientRect().left -
          4 +
          "px",
      })
      : this.setState({
        schoolleft:
          document
            .getElementsByClassName("value_item")[0]
            .getBoundingClientRect().left +
          -25 +
          "px",
      });
    // this.setState({ schoolleft: npi_tab.offsetWidth + 20 + "px" });
    this.setState({ tabdisplay: "block" });
  };
  // displayhandlersec = () => {
  //   this.setState({ tabdisplay: "none" });
  // };
  handlepricetabchange = (e) => {
    this.setState({ is_edit_click: false });
    this.setState({ metericon: "overall-grey.svg" });
    this.setState({ schoolicon: "school-grey.svg" });
    this.setState({ shieldicon: "safety-grey.svg" });
    this.setState({ walkingicon: "undervalued-grey.svg" });
    this.setState({ buildingicon: "amenities-grey.svg" });
    this.setState({ treeicon: "appreciation-grey.svg" });
    this.setState({ peopleicon: "people.svg" });
    this.setState({ home_moneyicon: "price-white.svg" });
    this.setState({ personicon: "personalized-grey.svg" });
    this.setState({ previous_active: "Price" });
    // if (e.target.text === "Price") {
    //   this.setState({ pricemaintxt: "Price" });
    //   this.setState({ pricetxt: "Price" });
    //   this.setState({ valuetxt: "Value" });
    //   this.setState({ priceactive: "active" });
    // } else if (e.target.text === "Value") {
    //   this.setState({ pricemaintxt: "Price" });
    //   this.setState({ pricetxt: "Price" });
    //   this.setState({ valuetxt: "Value" });
    //   this.setState({ priceactive: "active" });
    // }
    // if (this.state.pricetabdisplay === "none") {
    //   this.setState({ pricetabdisplay: "block" });
    // } else {
    //   this.setState({ pricetabdisplay: "none" });
    // }
    this.setState({ amenitiesactive: "" });
  };
  handleeditclick = () => {
    this.setState({ sactive: "" });
    this.setState({ amenitiesactive: "" });
    this.setState({ priceactive: "" });
    // if (this.state.isMobile) {
    //   this.setState({ viewMap: false });
    // }
    // this.setState({ personicon: "personalized-grey.svg" });
    // this.setState({ metericon: "overall-grey.svg" });
    // this.setState({ shieldicon: "safety-grey.svg" });
    // this.setState({ walkingicon: "undervalued-grey.svg" });
    // this.setState({ buildingicon: "amenities-grey.svg" });
    // this.setState({ treeicon: "appreciation-grey.svg" });
    // this.setState({ peopleicon: "people.svg" });
    // this.setState({ home_moneyicon: "price-grey.svg" });
    // this.setState({ schoolicon: "school-grey.svg" });
    // this.setState({ is_disable_lhp: true });
    this.setState({ is_edit_click: true });
    // this.setState({ rhpFactor: 1 });
  };
  handleClosepersonal = () => {
    this.setState({ is_edit_click: false });
  };
  handlefilterclick = () => {
    this.getMapRef()?.onseefulllistclick();
  };
  handleamenitiestabchange = (e) => {
    this.setState({ is_edit_click: false });
    this.setState({ buildingicon: "amenities-white.svg" });
    this.setState({ metericon: "overall-grey.svg" });
    this.setState({ schoolicon: "school-grey.svg" });
    this.setState({ shieldicon: "safety-grey.svg" });
    this.setState({ walkingicon: "undervalued-grey.svg" });
    this.setState({ treeicon: "appreciation-grey.svg" });
    this.setState({ peopleicon: "people.svg" });
    this.setState({ home_moneyicon: "price-grey.svg" });
    this.setState({ personicon: "personalized-grey.svg" });
    this.setState({ priceactive: "" });
    this.setState({ previous_active: "Amenities" });

    this.setState({ amenitiesactive: "active" });
    if (e.target.text === "Amenities") {
      this.amentiestext = "Amenities";
      this.setState({ amenitiestxt: "Amenities" });
      this.setState({ townctrtxt: "Near Merchants" });
      this.setState({ publictxt: "Public Spaces" });
      this.setState({ walktxt: "Walkable Streets" });
      this.setState({ curbtxt: "Curb Appeal" });
      this.setState({ allamenitiestxt: "All Amenities" });
      this.setState({ amenitiesactive: "active" });
    } else if (
      e.target.text === "Near Merchants" ||
      e.target.text === "Town Center"
    ) {
      this.amentiestext = "Near Merchants";
      this.setState({ amenitiestxt: "Near Merchants" });
      this.setState({ townctrtxt: "Near Merchants" });
      this.setState({ publictxt: "Public Spaces" });
      this.setState({ walktxt: "Walkable Streets" });
      this.setState({ curbtxt: "Curb Appeal" });
      this.setState({ allamenitiestxt: "All Amenities" });
      this.setState({ amenitiesactive: "active" });
    } else if (e.target.text === "Public Spaces") {
      this.amentiestext = "Public Spaces";
      this.setState({ amenitiestxt: "Public Spaces" });
      this.setState({ townctrtxt: "Near Merchants" });
      this.setState({ publictxt: "Public Spaces" });
      this.setState({ walktxt: "Walkable Streets" });
      this.setState({ curbtxt: "Curb Appeal" });
      this.setState({ allamenitiestxt: "All Amenities" });
      this.setState({ amenitiesactive: "active" });
    } else if (e.target.text === "Walkable Streets") {
      this.amentiestext = "Walkable Streets";
      this.setState({ amenitiestxt: "Walkable Streets" });
      this.setState({ townctrtxt: "Near Merchants" });
      this.setState({ publictxt: "Public Spaces" });
      this.setState({ walktxt: "Walkable Streets" });
      this.setState({ curbtxt: "Curb Appeal" });
      this.setState({ allamenitiestxt: "All Amenities" });
      this.setState({ amenitiesactive: "active" });
    } else if (e.target.text === "Curb Appeal") {
      this.amentiestext = "Curb Appeal";
      this.setState({ amenitiestxt: "Curb Appeal" });
      this.setState({ townctrtxt: "Near Merchants" });
      this.setState({ publictxt: "Public Spaces" });
      this.setState({ walktxt: "Walkable Streets" });
      this.setState({ curbtxt: "Curb Appeal" });
      this.setState({ allamenitiestxt: "All Amenities" });
      this.setState({ amenitiesactive: "active" });
    } else if (e.target.text === "All Amenities") {
      this.amentiestext = "All Amenities";
      this.setState({ amenitiestxt: "All Amenities" });
      this.setState({ townctrtxt: "Near Merchants" });
      this.setState({ publictxt: "Public Spaces" });
      this.setState({ walktxt: "Walkable Streets" });
      this.setState({ curbtxt: "Curb Appeal" });
      this.setState({ allamenitiestxt: "All Amenities" });
      this.setState({ amenitiesactive: "active" });
    }

    if (this.state.amenitiestabdisplay === "none") {
      this.setState({ amenitiestabdisplay: "block" });
    } else {
      this.setState({ amenitiestabdisplay: "none" });
    }
  };
  handleschooltabchange = (e) => {
    this.setState({ is_edit_click: false });
    this.setState({ previous_active: "School" });
    // if(this.state.schoolicon === "school-grey.svg"){
    this.setState({ metericon: "overall-grey.svg" });
    this.setState({ schoolicon: "school-white.svg" });
    this.setState({ shieldicon: "safety-grey.svg" });
    this.setState({ walkingicon: "undervalued-grey.svg" });
    this.setState({ buildingicon: "amenities-grey.svg" });
    this.setState({ treeicon: "appreciation-grey.svg" });
    this.setState({ peopleicon: "people.svg" });
    this.setState({ home_moneyicon: "price-grey.svg" });
    this.setState({ personicon: "personalized-grey.svg" });
    // }else{
    //   this.setState({schoolicon:"school-grey.svg"});
    // }

    if (e.target.text === "School") {
      this.schooltext = "School";
      this.setState({ schooltxt: "School" });
      this.setState({ eletxt: "Elementary" });
      this.setState({ middletxt: "Middle" });
      this.setState({ hightxt: "High" });
      this.setState({ allschooltxt: "All Schools" });
      this.setState({ sactive: "active" });
    } else if (e.target.text === "All Schools") {
      this.schooltext = "School";
      this.setState({ schooltxt: "All Schools" });
      this.setState({ eletxt: "Elementary" });
      this.setState({ middletxt: "Middle" });
      this.setState({ hightxt: "High" });
      //this.setState({allschooltxt:"School"});
      this.setState({ sactive: "active" });
    } else if (e.target.text === "Elementary") {
      this.schooltext = "Elementary";
      this.setState({ schooltxt: "Elementary" });
      //this.setState({eletxt:"School"});
      this.setState({ middletxt: "Middle" });
      this.setState({ hightxt: "High" });
      this.setState({ allschooltxt: "All Schools" });
      this.setState({ sactive: "active" });
    } else if (e.target.text === "Middle") {
      this.schooltext = "Middle";
      this.setState({ schooltxt: "Middle" });
      this.setState({ eletxt: "Elementary" });
      //this.setState({middletxt:"School"});
      this.setState({ allschooltxt: "All Schools" });
      this.setState({ hightxt: "High" });
      this.setState({ sactive: "active" });
    } else if (e.target.text === "High") {
      this.schooltext = "High";
      this.setState({ schooltxt: "High" });
      this.setState({ eletxt: "Elementary" });
      this.setState({ middletxt: "Middle" });
      //this.setState({hightxt:"School"});
      this.setState({ allschooltxt: "All Schools" });
      this.setState({ sactive: "active" });
    }
    if (this.state.tabdisplay === "none") {
      this.setState({ tabdisplay: "block" });
    } else {
      this.setState({ tabdisplay: "none" });
    }
  };
  renderMapButton = () => {
    if (this.state.isMobile || this.state.isTablet) {
      return (
        <div className="btn-list-wrapper btn-map-wrapper">
          <button
            className="btn"
            type="button"
            onClick={() => this.setState({ viewMap: true, isExpanded: false })}
          >
            Map
          </button>
        </div>
      );
    }
  };

  hideMapMask = () => {
    this.setState({ displayMapMask: false });
    this.setState({ tabdisplay: "none" });
  };

  handlealltabchange = (txtData) => {
    this.setState({ is_edit_click: false });
    let clickeditem = txtData;

    this.setState({ sactive: "" });
    this.setState({ amenitiesactive: "" });
    this.setState({ priceactive: "" });
    this.setState({ personalactive: "" });
    if (clickeditem === "NPI Score" || clickeditem === "Overall Score") {
      this.setState({ previous_active: "npi" });
      if (this.state.metericon === "overall-grey.svg") {
        this.setState({ metericon: "overall-white.svg" });
        this.setState({ shieldicon: "safety-grey.svg" });
        this.setState({ walkingicon: "undervalued-grey.svg" });
        this.setState({ buildingicon: "amenities-grey.svg" });
        this.setState({ treeicon: "appreciation-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ home_moneyicon: "price-grey.svg" });
        this.setState({ personicon: "personalized-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
      } else {
        this.setState({ metericon: "overall-grey.svg" });
      }
    }

    if (clickeditem === "Safety") {
      this.setState({ previous_active: "safety" });
      if (this.state.shieldicon === "safety-grey.svg") {
        this.setState({ shieldicon: "safety-white.svg" });
        this.setState({ metericon: "overall-grey.svg" });
        this.setState({ walkingicon: "undervalued-grey.svg" });
        this.setState({ buildingicon: "amenities-grey.svg" });
        this.setState({ treeicon: "appreciation-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ home_moneyicon: "price-grey.svg" });
        this.setState({ personicon: "personalized-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
      } else {
        this.setState({ shieldicon: "safety-grey.svg" });
      }
    }

    if (clickeditem === "Walkability") {
      this.setState({ previous_active: "Walkability" });
      if (this.state.walkingicon === "undervalued-grey.svg") {
        this.setState({ walkingicon: "undervalued-white.svg" });
        this.setState({ metericon: "overall-grey.svg" });
        this.setState({ buildingicon: "amenities-grey.svg" });
        this.setState({ treeicon: "appreciation-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ home_moneyicon: "price-grey.svg" });
        this.setState({ personicon: "personalized-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
        this.setState({ shieldicon: "safety-grey.svg" });
      } else {
        this.setState({ walkingicon: "undervalued-grey.svg" });
      }
    }

    if (clickeditem === "Town Center" || clickeditem === "Amenitites") {
      this.setState({ previous_active: "Amenitites" });
      if (this.state.buildingicon === "amenities-grey.svg") {
        this.setState({ buildingicon: "amenities-white.svg" });
        this.setState({ metericon: "overall-grey.svg" });
        this.setState({ walkingicon: "undervalued-grey.svg" });
        this.setState({ treeicon: "appreciation-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ home_moneyicon: "price-grey.svg" });
        this.setState({ personicon: "personalized-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
        this.setState({ shieldicon: "safety-grey.svg" });
      } else {
        this.setState({ buildingicon: "amenities-grey.svg" });
      }
    }

    if (clickeditem === "Appreciation") {
      this.setState({ previous_active: "Appreciation" });
      if (this.state.treeicon === "appreciation-grey.svg") {
        this.setState({ treeicon: "appreciation-white.svg" });
        this.setState({ metericon: "overall-grey.svg" });
        this.setState({ shieldicon: "safety-grey.svg" });
        this.setState({ walkingicon: "undervalued-grey.svg" });
        this.setState({ buildingicon: "amenities-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ home_moneyicon: "price-grey.svg" });
        this.setState({ personicon: "personalized-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
      } else {
        this.setState({ treeicon: "appreciation-grey.svg" });
      }
    }

    if (clickeditem === "Days on Market" || clickeditem === "dom") {
      if (this.state.walkingicon === "dom.svg") {
        this.setState({ walkingicon: "dom_red.svg" });
        this.setState({ metericon: "overall-grey.svg" });
        this.setState({ buildingicon: "amenities-grey.svg" });
        this.setState({ treeicon: "appreciation-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ home_moneyicon: "price-grey.svg" });
        this.setState({ personicon: "personalized-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
        this.setState({ shieldicon: "safety-grey.svg" });
      } else {
        this.setState({ walkingicon: "dom.svg" });
      }
    }

    if (clickeditem === "Value") {
      this.setState({ previous_active: "Value" });
      if (this.state.walkingicon === "undervalued-grey.svg") {
        this.setState({ home_moneyicon: "price-grey.svg" });
        this.setState({ metericon: "overall-grey.svg" });
        this.setState({ shieldicon: "safety-grey.svg" });
        this.setState({ walkingicon: "undervalued-white.svg" });
        this.setState({ buildingicon: "amenities-grey.svg" });
        this.setState({ treeicon: "appreciation-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ personicon: "personalized-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
      } else {
        this.setState({ walkingicon: "undervalued-grey.svg" });
      }
    }

    if (clickeditem === "Price") {
      this.setState({ previous_active: "Price" });
      if (this.state.home_moneyicon === "price-grey.svg") {
        this.setState({ home_moneyicon: "price-white.svg" });
        this.setState({ metericon: "overall-grey.svg" });
        this.setState({ shieldicon: "safety-grey.svg" });
        this.setState({ walkingicon: "undervalued-grey.svg" });
        this.setState({ buildingicon: "amenities-grey.svg" });
        this.setState({ treeicon: "appreciation-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ personicon: "personalized-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
      } else {
        this.setState({ home_moneyicon: "price-grey.svg" });
      }
    }

    if (clickeditem === "Personalize Search") {
      // if (this.state.isMobile) {
      //   this.setState({ viewMap: false });
      // }
    }
    if (clickeditem === "Personalize Search" && this.state.rhpFactor === 0) {
      this.setState({ rhpFactor: 1 });
      localStorage.setItem("is_from_cityclick", "Y");
      // if (this.state.isMobile) {
      //   this.setState({ viewMap: false });
      // }
    }

    if (
      clickeditem === "Personalize Search" ||
      clickeditem === "Personal Score"
    ) {
      this.setState({ previous_active: "Personal" });
      if (this.state.personicon === "personalized-grey.svg") {
        this.setState({ personicon: "personalized-white.svg" });
        this.setState({ metericon: "overall-grey.svg" });
        this.setState({ shieldicon: "safety-grey.svg" });
        this.setState({ walkingicon: "undervalued-grey.svg" });
        this.setState({ buildingicon: "amenities-grey.svg" });
        this.setState({ treeicon: "appreciation-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ home_moneyicon: "price-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
      } else {
        this.setState({ personicon: "personalized-grey.svg" });
        this.setState({ metericon: "overall-grey.svg" });
        this.setState({ shieldicon: "safety-grey.svg" });
        this.setState({ walkingicon: "undervalued-grey.svg" });
        this.setState({ buildingicon: "amenities-grey.svg" });
        this.setState({ treeicon: "appreciation-grey.svg" });
        this.setState({ peopleicon: "people.svg" });
        this.setState({ home_moneyicon: "price-grey.svg" });
        this.setState({ schoolicon: "school-grey.svg" });
      }
      if (this.state.editabdisplay === "none") {
        this.setState({ editabdisplay: "block" });
      } else {
        this.setState({ editabdisplay: "none" });
      }
    }
  };

  handleschoolbarChange = (schoolbar) => {
    this.setState({ schoolbar_val: schoolbar });
  };
  handlecrimebarChange = (crimebar) => {
    this.setState({ crimebar_val: crimebar });
  };
  handletownbarChange = (townbar) => {
    this.setState({ townbar_val: townbar });
  };
  handlecurbbarChange = (curbbar) => {
    this.setState({ curbbar_val: curbbar });
  };
  handlewalkbarChange = (walkbar) => {
    this.setState({ walkbar_val: walkbar });
  };
  handlecommbarChange = (commbar) => {
    this.setState({ commbar_val: commbar });
  };
  handlevaluebarChange = (valuebar) => {
    this.setState({ valuebar_val: valuebar });
  };
  handlepricemaxChange = (pricemax) => {
    this.setState({ pricemax_val: pricemax });
  };
  handlepriceminChange = (pricemin) => {
    this.setState({ pricemin_val: pricemin });
  };
  handletabclick = (data) => {
    this.setState({ is_disable_lhp: data });
  };

  handleCloseaddress = () => {
    this.getMapRef()?.handleCloseClick();
  };

  render() {
    const LHPpanes = (context) => {
      return [
        {
          menuItem: (
            //  <span ref={this.myInput}>
            <Menu.Item
              key="NPI"
              id="menu_item_first"
              name="NPI Score"
              onClick={() => this.handlealltabchange("NPI Score")}
              disabled={!this.state.is_disable_lhp ? false : true}
              className={`${context?.checkactive?.props?.activeIndex === 0 &&
                this.state.previous_active === "npi" &&
                "active"
                } ${(this.state.isMobile || this.state.isTablet) &&
                  this.state.visibleSet === 1
                  ? "b-block-mb"
                  : "b-none-mb"
                }`}
            >
              <div className="menu_icons">
                <img
                  src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/factors/${this.state.metericon}`}
                  title="NPI Score"
                  alt="NPI"
                />
                Overall Score
              </div>
            </Menu.Item>
            //  </span>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                isthirdclick={this.state.isthirdclick}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                boundrycoordsdata={this.state.boundrycoordsdata}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          ...(!this.state.isMobile &&
            !this.state.isTablet && {
            menuItem: (
              <Menu.Item
                key="Personal"
                className={`per_search ${this.state.personalactive} ${this.state.previous_active === "Personal" && "active"
                  } ${(this.state.isMobile || this.state.isTablet) &&
                    this.state.visibleSet === 1
                    ? "b-block-mb"
                    : "b-none-mb"
                  }`}
                onClick={() =>
                  this.handlealltabchange(this.state.personal_txt)
                }
                onMouseEnter={() => this.displayhandleredit()}
                onMouseLeave={() => this.displayunhandleredit()}
                disabled={!this.state.is_disable_lhp ? false : true}
                id="menu_item_sec"
              >
                <div className="menu_icons">
                  <img
                    src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/factors/${this.state.personicon}`}
                    title={this.state.personal_txt}
                    alt="personal score"
                  />
                  {this.state.personal_txt}
                </div>
              </Menu.Item>
            ),
            render: () => (
              <Tab.Pane>
                <Map
                  ref={"map"}
                  onChange={context.mapChangeHandler}
                  singleHome={context.singleHomeHandler}
                  addressInfo={context}
                  neighbors={context.NeighbordataHandler}
                  singleNeighbor={context.singleNeighborHandler}
                  singleCity={context.singleCityHandler}
                  savedhomes={context.savedhomehandler}
                  savedneighbor={context.savedneighborhandler}
                  savedcity={context.savedcityhandler}
                  recommendedneighbor={context.recommendedneighborhandler}
                  hoverdnhid={this.state.hoverdnhid}
                  unhoverd={this.state.unhoverd}
                  schoolbar_val={this.state.schoolbar_val}
                  crimebar_val={this.state.crimebar_val}
                  townbar_val={this.state.townbar_val}
                  curbbar_val={this.state.curbbar_val}
                  walkbar_val={this.state.walkbar_val}
                  commbar_val={this.state.commbar_val}
                  valuebar_val={this.state.valuebar_val}
                  pricemax_val={this.state.pricemax_val}
                  pricemin_val={this.state.pricemin_val}
                  personal_txt={this.state.personal_txt}
                  homefiltercount={this.filterhomecounthandler}
                  handletab={this.handletabclick}
                  singleClick={context.singleClickHandler}
                  checkRhptab={context.checkrhptabHandler}
                  checkschool={context.checkschool}
                  heart={this.state.nhheart}
                  save={this.getsavednhdata}
                  singleneighbordata={this.state.singleneighbordata}
                  centercityname={context.getCenterCityname}
                  centercountyname={context.getCenterCountyname}
                ></Map>
              </Tab.Pane>
            ),
          }),
        },
        {
          menuItem: (
            <Menu.Item
              key="School"
              className={`value_item sc_clas menu_item_laptop ${this.state.sactive
                } ${this.state.previous_active === "School" && "active"} ${(this.state.isMobile || this.state.isTablet) &&
                  this.state.visibleSet === 1
                  ? "b-block-mb"
                  : "b-none-mb"
                }`}
              onClick={(e) => this.handleschooltabchange(e)}
              onMouseEnter={() => this.displayhandler()}
              onMouseLeave={() => this.displayhandlersec()}
              disabled={!this.state.is_disable_lhp ? false : true}
              id="menu_item_third"
            >
              <div className="menu_icons ">
                <img
                  src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/factors/${this.state.schoolicon}`}
                  alt={this.state.schooltxt}
                  title={this.state.schooltxt}
                />
                {this.state.schooltxt}
              </div>
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Crime"
              className={`sc_clas menu_item_laptop ${this.state.previous_active === "safety" && "active"
                } ${(this.state.isMobile || this.state.isTablet) &&
                  this.state.visibleSet === 1
                  ? "b-block-mb"
                  : "b-none-mb"
                }`}
              onClick={() => this.handlealltabchange("Safety")}
              disabled={!this.state.is_disable_lhp ? false : true}
              id="menu_item_forth"
            >
              <div className="menu_icons">
                <img
                  src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/factors/${this.state.shieldicon}`}
                  title="Safety"
                  alt="Safety"
                />
                Safety
              </div>
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Town Center"
              onClick={(e) => this.handleamenitiestabchange(e)}
              onMouseEnter={() => this.displayhandleramenities()}
              onMouseLeave={() => this.displayunhandleramenities()}
              disabled={!this.state.is_disable_lhp ? false : true}
              id="menu_item_fifth"
              className={`sc_clas amenities_main menu_item_laptop ${this.state.amenitiesactive
                } ${this.state.previous_active === "Amenities" && "active"} ${this.state.isMobile || this.state.isTablet
                  ? this.state.visibleSet === 1
                    ? "b-block-mb"
                    : "b-none-mb"
                  : this.state.visibleSet === 2
                    ? "b-block-mb"
                    : "b-none-mb"
                }`}
            >
              <div className="menu_icons">
                <img
                  src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/factors/${this.state.buildingicon}`}
                  title="Town Center"
                  alt="Town center"
                />
                {this.state.amenitiestxt}
              </div>
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Price"
              onClick={(e) => this.handlepricetabchange(e)}
              //onMouseEnter={() => this.displayhandlerprice()}
              //onMouseLeave={() => this.displayunhandlerprice()}
              disabled={!this.state.is_disable_lhp ? false : true}
              className={`value_item price_cls sc_clas menu_item_laptop ${this.state.priceactive
                } ${this.state.previous_active === "Price" && "active"} ${(this.state.isMobile && this.state.visibleSet === 2) ||
                  (this.state.isTablet && this.state.visibleSet === 1)
                  ? "b-block-mb"
                  : "b-none-mb"
                }`}
              id="menu_item_six"
            >
              <div className="menu_icons">
                <img
                  src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/factors/${this.state.home_moneyicon}`}
                  title="Price"
                  alt="Price"
                />
                {this.state.pricemaintxt}
              </div>
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Value"
              onClick={() => this.handlealltabchange("Value")}
              className={`sc_clas day_market ${this.state.previous_active === "Value" && "active"
                } ${(this.state.isMobile && this.state.visibleSet === 2) ||
                  (this.state.isTablet && this.state.visibleSet === 1)
                  ? "b-block-mb"
                  : "b-none-mb"
                }`}
              disabled={!this.state.is_disable_lhp ? false : true}
              id="menu_item_eight"
            >
              <div className="menu_icons">
                <img
                  src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/factors/${this.state.walkingicon}`}
                  title="Value"
                  alt="value"
                />
                Value
              </div>
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Appreciation"
              onClick={() => this.handlealltabchange("Appreciation")}
              disabled={!this.state.is_disable_lhp ? false : true}
              id="menu_item_seven"
              className={`sc_clas menu_item_laptop ${this.state.previous_active === "Appreciation" && "active"
                } ${(this.state.isMobile && this.state.visibleSet === 2) ||
                  (this.state.isTablet && this.state.visibleSet === 1)
                  ? "b-block-mb"
                  : "b-none-mb"
                }`}
            >
              <div className="menu_icons">
                <img
                  src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/factors/${this.state.treeicon}`}
                  title="Appreciation"
                  alt="Appreciation"
                />
                Appreciation
              </div>
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="allschools"
              className="allschool_cls common_sec "
              style={{
                display: this.state.tabdisplay,
                left: this.state.schoolleft,
                width: this.state.schoolwidth,
              }}
              onClick={(e) => this.handleschooltabchange(e)}
              onMouseEnter={() => this.displayhandler()}
              onMouseLeave={() => this.displayhandlersec()}
              handletab={this.handletabclick}
            >
              {this.state.allschooltxt}
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Elementry"
              className="elementry_cls common_sec"
              style={{
                display: this.state.tabdisplay,
                left: this.state.schoolleft,
                width: this.state.schoolwidth,
              }}
              onClick={(e) => this.handleschooltabchange(e)}
              onMouseEnter={() => this.displayhandler()}
              onMouseLeave={() => this.displayhandlersec()}
              handletab={this.handletabclick}
            >
              {this.state.eletxt}
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Middle"
              className="middle_cls common_sec"
              style={{
                display: this.state.tabdisplay,
                left: this.state.schoolleft,
                width: this.state.schoolwidth,
              }}
              onClick={(e) => this.handleschooltabchange(e)}
              onMouseEnter={() => this.displayhandler()}
              onMouseLeave={() => this.displayhandlersec()}
              handletab={this.handletabclick}
            >
              {this.state.middletxt}
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="High"
              className="high_cls common_sec"
              style={{
                display: this.state.tabdisplay,
                left: this.state.schoolleft,
                width: this.state.schoolwidth,
              }}
              onClick={(e) => this.handleschooltabchange(e)}
              onMouseEnter={() => this.displayhandler()}
              onMouseLeave={() => this.displayhandlersec()}
              handletab={this.handletabclick}
            >
              {this.state.hightxt}
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Near Merchants"
              className="near_town_cls common_sec_amenities"
              style={{
                display: this.state.amenitiestabdisplay,
                left: this.state.amenitiesleft,
                width: this.state.amenitieswidth,
              }}
              onClick={(e) => this.handleamenitiestabchange(e)}
              onMouseEnter={() => this.displayhandleramenities()}
              onMouseLeave={() => this.displayunhandleramenities()}
              handletab={this.handletabclick}
            >
              {this.state.townctrtxt}
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Public Spaces"
              className="public_spaces common_sec_amenities"
              style={{
                display: this.state.amenitiestabdisplay,
                left: this.state.amenitiesleft,
                width: this.state.amenitieswidth,
              }}
              onClick={(e) => this.handleamenitiestabchange(e)}
              onMouseEnter={() => this.displayhandleramenities()}
              onMouseLeave={() => this.displayunhandleramenities()}
              handletab={this.handletabclick}
            >
              {this.state.publictxt}
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Walkable Streets"
              className="walkable_streets common_sec_amenities"
              style={{
                display: this.state.amenitiestabdisplay,
                left: this.state.amenitiesleft,
                width: this.state.amenitieswidth,
              }}
              onClick={(e) => this.handleamenitiestabchange(e)}
              onMouseEnter={() => this.displayhandleramenities()}
              onMouseLeave={() => this.displayunhandleramenities()}
              handletab={this.handletabclick}
            >
              {this.state.walktxt}
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Curb Appeal"
              className="curb_appeal common_sec_amenities"
              style={{
                display: this.state.amenitiestabdisplay,
                left: this.state.amenitiesleft,
                width: this.state.amenitieswidth,
              }}
              onClick={(e) => this.handleamenitiestabchange(e)}
              onMouseEnter={() => this.displayhandleramenities()}
              onMouseLeave={() => this.displayunhandleramenities()}
              handletab={this.handletabclick}
            >
              {this.state.curbtxt}
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="All Amenities"
              className="all_amenities common_sec_amenities"
              style={{
                display: this.state.amenitiestabdisplay,
                left: this.state.amenitiesleft,
                width: this.state.amenitieswidth,
              }}
              onClick={(e) => this.handleamenitiestabchange(e)}
              onMouseEnter={() => this.displayhandleramenities()}
              onMouseLeave={() => this.displayunhandleramenities()}
              handletab={this.handletabclick}
            >
              {this.state.allamenitiestxt}
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item
              key="Edit"
              className="edit_perosnal"
              style={{
                display: this.state.editabdisplay,
                left: this.state.editleft,
                width: this.state.editwidth,
              }}
              onMouseEnter={() => this.displayhandleredit()}
              onMouseLeave={() => this.displayunhandleredit()}
              onClick={(e) => this.handleeditclick(e)}
              handletab={this.handletabclick}
            >
              Edit
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane>
              <Map
                ref={"map"}
                onChange={context.mapChangeHandler}
                singleHome={context.singleHomeHandler}
                addressInfo={context}
                neighbors={context.NeighbordataHandler}
                singleNeighbor={context.singleNeighborHandler}
                singleCity={context.singleCityHandler}
                savedhomes={context.savedhomehandler}
                savedneighbor={context.savedneighborhandler}
                savedcity={context.savedcityhandler}
                recommendedneighbor={context.recommendedneighborhandler}
                hoverdnhid={this.state.hoverdnhid}
                unhoverd={this.state.unhoverd}
                schoolbar_val={this.state.schoolbar_val}
                crimebar_val={this.state.crimebar_val}
                townbar_val={this.state.townbar_val}
                curbbar_val={this.state.curbbar_val}
                walkbar_val={this.state.walkbar_val}
                commbar_val={this.state.commbar_val}
                valuebar_val={this.state.valuebar_val}
                pricemax_val={this.state.pricemax_val}
                pricemin_val={this.state.pricemin_val}
                personal_txt={this.state.personal_txt}
                homefiltercount={this.filterhomecounthandler}
                handletab={this.handletabclick}
                singleClick={context.singleClickHandler}
                checkRhptab={context.checkrhptabHandler}
                checkschool={context.checkschool}
                heart={this.state.nhheart}
                save={this.getsavednhdata}
                singleneighbordata={this.state.singleneighbordata}
                centercityname={context.getCenterCityname}
                centercountyname={context.getCenterCountyname}
              ></Map>
            </Tab.Pane>
          ),
        },
        ,
      ];
    };
    let {
      smodal,
      lmodal,
      viewMap,
      isMobile,
      displayMapMask,
      isTab,
      run,
      steps,
      isTablet,
      isDeviceChecked,
    } = this.state;

    const params = {
      paginationClickable: true,
      spaceBetween: 10,
      slidesPerView: 5,
    };
    if (isDeviceChecked === null) {
      return null;
    }
    return (
      <ErrorBoundary>
        <>
          <div className="home-wrapper">
            <Head>
              <title>Houseberry: Welcome</title>
              <link rel="canonical" href="https://www.houseberry.com/" />
              <meta
                property="og:image"
                content={
                  process.env.NEXT_PUBLIC_CDN_ID + "static/images/seoimg.png"
                }
              />

              <meta
                name="description"
                content="Houseberry helps you find your ideal neighborhood first. Explore neighborhood scores on schools, safety, amenities, price, value, and appreciation - and homes for sale in your perfect area."
              ></meta>
              <meta
                name="keywords"
                content="Houseberry, neighborhood finder, home search, neighborhood-first"
              ></meta>
            </Head>
            {/* <Joyride
            callback={this.handleJoyrideCallback}
            continuous
            hideCloseButton
            run={run}
            scrollToFirstStep
            showProgress={false}
            showSkipButton
            steps={steps}
            styles={{
              options: {
                arrowColor: "#787879",
                backgroundColor: "rgb(147 147 147)",
                // overlayColor: "rgba(79, 26, 0, 0.4)",
                primaryColor: "#000",
                textColor: "#fff",
                // width: 900,
                zIndex: 1100,
              },
            }}
          /> */}

            <Layout
              tagline
              search={true}
              address={this.state.address}
              nhmap={true}
              searchOnSelect={this.handleSelects}
              searchhandleAddressChange={this.handleAddressChange}
              is_loading={this.state.is_loading}
              handleCloseaddress={this.handleCloseaddress}
            >
              <Container
                fluid
                style={{ padding: "5px 20px 0px 20px" }}
                className={isMobile || isTablet ? "map-wrapper" : ""}
              >
                <Grid
                  divided
                  stackable
                // style={{ minHeight: 300 }}
                //className="star-burst"
                >
                  <Grid.Column
                    computer={isTablet ? undefined : 11}
                    tablet={16}
                    mobile={16}
                    className="min_width_cls nav_item_laptop nhmap_top_grid"
                    style={{ display: !viewMap ? "none" : "inline-block" }}
                    id={
                      isMobile && this.state.singleneighbordata.length !== 0
                        ? "mobile_single"
                        : ""
                    }
                  >
                    <span className="search_by">Map Neighborhoods by:</span>
                    <div className="tab_main_top">
                      {this.state.is_loaded && (
                        <div className="top_txt_main">
                          {!isTablet && this.state.is_dispaly_top_text && (
                            <Grid.Row>
                              <div
                                className="top_main"
                                ref={this.contentScroll}
                              >
                                <div
                                  className="first_sec top_sec_txt"
                                  id="top_first_sec"
                                  style={{
                                    width: isTab && this.state.top_first_sec,
                                    // float: "left",
                                  }}
                                >
                                  <span className="search_by_txt">
                                    Overall Quality
                                  </span>
                                </div>
                                <div
                                  className="second_sec top_sec_txt"
                                  id="top_second_sec"
                                  style={{
                                    width: isTab && this.state.top_second_sec,
                                    // float: "left",
                                    textAlign: "center",
                                  }}
                                >
                                  Neighborhood Factors
                                </div>
                                <div
                                  className="third_sec top_sec_txt"
                                  id="top_third_sec"
                                  style={{
                                    width: isTab && this.state.top_third_sec,
                                    // float: "left",
                                    textAlign: "center",
                                  }}
                                >
                                  Market Conditions
                                </div>
                              </div>
                            </Grid.Row>
                          )}
                        </div>
                      )}
                      <Grid.Row style={{ flex: 1 }}>
                        {this.state.is_loaded && isMobile && (
                          <>
                            <div
                              className="scroll-to-left"
                              onClick={this.scrollLeft}
                              style={{ visibility: "hidden" }}
                            >
                              <Icon name="angle left" />
                            </div>
                            <div
                              className="scroll-to-right"
                              onClick={this.scrollRight}
                            >
                              <Icon name="angle right" />
                            </div>
                          </>
                        )}
                        {this.state.is_loaded ? (
                          <Tab
                            ref={(c) => {
                              this.tabRef = c;
                              this.checkactive = c;
                              this.topScroll = c;
                            }}
                            onTabChange={this.handleChange}
                            onScroll={this.handleTabscroll}
                            menu={{
                              className: `nav-menu-item blue star-burst ${isMobile ? "menu-item-selection" : ""
                                }`,
                            }}
                            panes={LHPpanes(this)}
                            activeIndex={this.state.lhpFactor}
                            renderActiveOnly={true}
                            className="top_left_panes"
                          />
                        ) : (
                          <div style={{ width: "100%", height: "88vh" }}>
                            <img
                              src={
                                isMobile
                                  ? process.env.NEXT_PUBLIC_CDN_ID +
                                  "static/images/defaultmap-mobile.png"
                                  : isTablet
                                    ? process.env.NEXT_PUBLIC_CDN_ID +
                                    "static/images/default-tablate.png"
                                    : process.env.NEXT_PUBLIC_CDN_ID +
                                    "static/images/defaultmap.png"
                              } // <-- replace with your image path
                              alt="Loading..."
                              style={{
                                width: "100%",
                                height: "100%",
                              }}
                            />
                          </div>
                        )}

                        <ViewToggle
                          onToggle={this.handleViewChange}
                          defaultSelected="Map View"
                        />
                        {isMobile &&
                          this.state.singleneighbordata.length === 0 && (
                            <div
                              className="mobile-drawer"
                              // onTouchStart={this.handleTouchStart}
                              // onTouchMove={this.handleTouchMove}
                              // onTouchEnd={this.handleTouchEnd}
                              style={{
                                transform: this.state.isExpanded
                                  ? `translateY(${this.state.translateY}px)`
                                  : `translateY(calc(100% - 50px + ${this.state.translateY}px))`,
                                transition: this.state.dragging
                                  ? "none"
                                  : "transform 0.3s ease",
                              }}
                            >
                              <div
                                className="handle-arrow"
                                onClick={() => this.handleToggleExpand()}
                              >
                                <div
                                  className={`arrow ${this.state.isExpanded ? "down" : "up"
                                    }`}
                                ></div>
                              </div>

                              {!this.state.isExpanded && (
                                <p
                                  className="panel-title"
                                  onClick={() => this.handleToggleExpand()}
                                >
                                  Top Neighborhoods
                                </p>
                              )}
                              <div
                                className="drawer-inner-scrollable"
                                style={{ overflowY: "auto", flexGrow: 1 }}
                              >
                                <Grid.Column
                                  width={16}
                                  className="map_right_blk drawer-inner-scrollable"
                                  id="map_right_top"
                                >
                                  {/* <p className="map_right_title">
                                  Top List in Map
                                </p> */}
                                  <Tab
                                    onTabChange={this.handleChangeRHP}
                                    menu={{
                                      className:
                                        "blue nav-menu-item home-tab-list",
                                    }}
                                    panes={[
                                      {
                                        menuItem: "Cities",
                                        render: () => (
                                          <Tab.Pane
                                            style={{
                                              overflowY: "scroll",
                                              height:
                                                this.state.height + tabPadding,
                                            }}
                                            className="tab_content"
                                          >
                                            {this.renderMapButton()}

                                            <Cities
                                              ref={this.homesRef}
                                              data={this.state.citydata}
                                              // selecteddata={this.state.neighbordata}
                                              userdata={this.state.userdata}
                                              saveddata={
                                                this.state.savedcitydata
                                              }
                                              selectedtab={this.state.lhpFactor}
                                              personal_txt={
                                                this.state.personal_txt
                                              }
                                              singlecitydata={
                                                this.state.singlecitydata
                                              }
                                              personalize_data={
                                                this.state.personalize_data
                                              }
                                              is_from_personal={
                                                this.state.is_from_personal
                                              }
                                              handleCityHoverRight={
                                                this.handleCityHoverRight
                                              }
                                              handleCityUnHoverRight={
                                                this.handleCityUnHoverRight
                                              }
                                              handleCityClick={
                                                this.handleCityClick
                                              }
                                              heart={this.state.cityheart}
                                              save={this.getsavedcitydata}
                                              nhsaved={this.state.nhsaved}
                                              citycentername={
                                                this.state.CentercityName
                                              }
                                              postalcityfullname={
                                                this.state.postalcityfullname
                                              }
                                              countyname={
                                                this.state.CentercountyName
                                              }
                                              countyfullname={
                                                this.state.countyfullname
                                              }
                                            ></Cities>
                                            <div className="mt-30">
                                              <LandingFooter />
                                            </div>
                                          </Tab.Pane>
                                        ),
                                      },
                                      {
                                        menuItem: "Neighborhoods",
                                        render: () => (
                                          <Tab.Pane
                                            style={{
                                              overflowY: "scroll",
                                              height:
                                                this.state.height + tabPadding,
                                            }}
                                            className="tab_content"
                                          >
                                            {this.renderMapButton()}

                                            <Neighbourhood
                                              data={this.state.neighborhood}
                                              ref={this.homesRef}
                                              neighborsingledata={
                                                this.state.singleneighbordata
                                              }
                                              walkscoredata={
                                                this.state.walkscoredata
                                              }
                                              selectedData={
                                                this.state.selectedNeighbour
                                              }
                                              userdata={this.state.userdata}
                                              loaddata={
                                                this.state.loaderdisplayicon
                                              }
                                              saveddata={
                                                this.state.savedneighbordata
                                              }
                                              checkuser={this.checkUser}
                                              recommendedneighbordata={
                                                this.state
                                                  .recommendedneighbordata
                                              }
                                              prefindval={this.state.prefindval}
                                              preuserid={this.state.preuserid}
                                              checkusergo={this.checkUsergo}
                                              handleHoverRight={
                                                this.handleHoverRight
                                              }
                                              handleClickRight={
                                                this.handleClickRight
                                              }
                                              handleUnhoverRight={
                                                this.handleUnhoverRight
                                              }
                                              selectedtab={this.state.lhpFactor}
                                              school_bar_change={
                                                this.handleschoolbarChange
                                              }
                                              crime_bar_change={
                                                this.handlecrimebarChange
                                              }
                                              town_bar_change={
                                                this.handletownbarChange
                                              }
                                              curb_bar_change={
                                                this.handlecurbbarChange
                                              }
                                              walk_bar_change={
                                                this.handlewalkbarChange
                                              }
                                              comm_bar_change={
                                                this.handlecommbarChange
                                              }
                                              value_bar_change={
                                                this.handlevaluebarChange
                                              }
                                              pricemax_change={
                                                this.handlepricemaxChange
                                              }
                                              pricemin_change={
                                                this.handlepriceminChange
                                              }
                                              heart={this.state.nhheart}
                                              save={this.getsavednhdata}
                                              checkPersonal={
                                                this.handlecheckpersonal
                                              }
                                              personal_txt={
                                                this.state.personal_txt
                                              }
                                              lmodal={this.state.lmodal}
                                              smodal={this.state.smodal}
                                              loggedin_user_id={
                                                this.state.userId
                                              }
                                              personalize_data={
                                                this.state.personalize_data
                                              }
                                              selectedpersonaldata={
                                                this.state.selectedpersonaldata
                                              }
                                              handlesinglecancel={
                                                this.handlesinglecancel
                                              }
                                              is_from_personal={
                                                this.state.is_from_personal
                                              }
                                              isMobile={this.state.isMobile}
                                              nhsaved={this.state.nhsaved}
                                              is_edit_click={
                                                this.state.is_edit_click
                                              }
                                              handleClosepersonal={
                                                this.handleClosepersonal
                                              }
                                              handlefilterclick={
                                                this.handlefilterclick
                                              }
                                              citycentername={
                                                this.state.CentercityName
                                              }
                                              postalcityfullname={
                                                this.state.postalcityfullname
                                              }
                                              countyname={
                                                this.state.CentercountyName
                                              }
                                              countyfullname={
                                                this.state.countyfullname
                                              }
                                            ></Neighbourhood>
                                            <div className="mt-30">
                                              <LandingFooter />
                                            </div>
                                          </Tab.Pane>
                                        ),
                                      },
                                      {
                                        menuItem: "Homes",
                                        render: () => (
                                          <>
                                            {/* <Grid
                                              style={{ marginBottom: "10px" }}
                                            >
                                              <Grid.Column
                                                width={16}
                                                style={{
                                                  textAlign: "center",
                                                  paddingBottom: "0px",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                <Grid.Row>
                                                  <Button
                                                    primary
                                                    id="filter_btn"
                                                    onClick={this.filterHome}
                                                  >
                                                    Filter Homes
                                                  </Button>
                                                </Grid.Row>
                                              </Grid.Column>
                                            </Grid> */}
                                            <Tab.Pane
                                              style={{
                                                overflowY: "scroll",
                                                height:
                                                  this.state.height +
                                                  tabPadding,
                                              }}
                                              className="tab_content"
                                            >
                                              {this.renderMapButton()}

                                              <Homes
                                                data={this.state.homesdata}
                                                saveddata={
                                                  this.state.savedhomedata
                                                }
                                                ref={this.homesRef}
                                                homesingledata={
                                                  this.state.singlehomedata
                                                }
                                                selectedData={
                                                  this.state.selectedNeighbour
                                                }
                                                filterHome={
                                                  this.state.filterHome
                                                }
                                                getdatafromhomes={
                                                  this.getdatafromhomes
                                                }
                                                getfiltersdata={
                                                  this.state.getdatafromhomes
                                                }
                                                userdata={this.state.userdata}
                                                userId={this.state.userId}
                                                save={this.getsavedhomedata}
                                                heart={this.state.heart}
                                                handleHomesHoverRight={
                                                  this.handleHomesHoverRight
                                                }
                                                handleHomesUnhoverRight={
                                                  this.handleHomesUnhoverRight
                                                }
                                                filter_homes_count={
                                                  this.state.filter_homes_count
                                                }
                                                is_from_personal={
                                                  this.state.is_from_personal
                                                }
                                                nhsaved={this.state.nhsaved}
                                                zoomlevel={this.state.zoom}
                                                citycentername={
                                                  this.state.CentercityName
                                                }
                                                postalcityfullname={
                                                  this.state.postalcityfullname
                                                }
                                                countyname={
                                                  this.state.CentercountyName
                                                }
                                                countyfullname={
                                                  this.state.countyfullname
                                                }
                                              ></Homes>
                                              <div className="mt-30">
                                                <LandingFooter />
                                              </div>
                                            </Tab.Pane>
                                          </>
                                        ),
                                      },
                                    ]}
                                    activeIndex={this.state.rhpFactor}
                                  />
                                </Grid.Column>
                              </div>
                            </div>
                          )}
                        {isMobile && (
                          <div className="selected-region-wrapper">
                            {/* <div className="btn-list-wrapper">
                              <button
                                className="btn"
                                onClick={() =>
                                  this.setState({ viewMap: false })
                                }
                              >
                                List
                              </button>
                            </div> */}
                            {this.state.singleneighbordata.length !== 0 && (
                              <SelectedNeighbourhood
                                neighborsingledata={
                                  this.state.singleneighbordata
                                }
                                personalize_data={this.state.personalize_data}
                                userId={this.state.userId}
                                personal_txt={this.state.personal_txt}
                                neighborhoodclose={this.handlesinglecancel}
                              />
                            )}
                            {!isMobile &&
                              Array.isArray(this.state.singlehomedata) &&
                              this.state.singlehomedata.length !== 0 && (
                                <SelectedHome
                                  homesingledata={this.state.singlehomedata}
                                  save={this.getsavedhomedata}
                                  heart={this.state.heart}
                                />
                              )}
                          </div>
                        )}
                      </Grid.Row>
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    width={5}
                    className={"map_right_blk"}
                    id="map_right_top"
                    style={{
                      display:
                        (isMobile || isTablet) && viewMap
                          ? "none"
                          : "inline-block",
                    }}
                  >
                    <p className="map_right_title">Top List in Map</p>
                    <Tab
                      onTabChange={this.handleChangeRHP}
                      menu={{ className: "blue nav-menu-item home-tab-list" }}
                      panes={[
                        {
                          menuItem: "Cities",
                          render: () => (
                            <Tab.Pane
                              style={{
                                overflowY: "scroll",
                                height: this.state.height + tabPadding,
                              }}
                              className="tab_content"
                            >
                              {this.renderMapButton()}

                              <Cities
                                ref={this.homesRef}
                                data={this.state.citydata}
                                // selecteddata={this.state.neighbordata}
                                userdata={this.state.userdata}
                                saveddata={this.state.savedcitydata}
                                selectedtab={this.state.lhpFactor}
                                personal_txt={this.state.personal_txt}
                                singlecitydata={this.state.singlecitydata}
                                personalize_data={this.state.personalize_data}
                                is_from_personal={this.state.is_from_personal}
                                handleCityHoverRight={this.handleCityHoverRight}
                                handleCityUnHoverRight={
                                  this.handleCityUnHoverRight
                                }
                                handleCityClick={this.handleCityClick}
                                heart={this.state.cityheart}
                                save={this.getsavedcitydata}
                                nhsaved={this.state.nhsaved}
                                citycentername={this.state.CentercityName}
                                postalcityfullname={
                                  this.state.postalcityfullname
                                }
                                countyname={this.state.CentercountyName}
                                countyfullname={this.state.countyfullname}
                              ></Cities>
                              <div className="mt-30">
                                <LandingFooter />
                              </div>
                            </Tab.Pane>
                          ),
                        },
                        {
                          menuItem: "Neighborhoods",
                          render: () => (
                            <Tab.Pane
                              style={{
                                overflowY: "scroll",
                                height: this.state.height + tabPadding,
                              }}
                              className="tab_content"
                            >
                              {this.renderMapButton()}
                              {this.state.is_loaded ? (
                                <Neighbourhood
                                  data={this.state.neighborhood}
                                  ref={this.homesRef}
                                  neighborsingledata={
                                    this.state.singleneighbordata
                                  }
                                  walkscoredata={this.state.walkscoredata}
                                  selectedData={this.state.selectedNeighbour}
                                  userdata={this.state.userdata}
                                  loaddata={this.state.loaderdisplayicon}
                                  saveddata={this.state.savedneighbordata}
                                  checkuser={this.checkUser}
                                  recommendedneighbordata={
                                    this.state.recommendedneighbordata
                                  }
                                  prefindval={this.state.prefindval}
                                  preuserid={this.state.preuserid}
                                  checkusergo={this.checkUsergo}
                                  handleHoverRight={this.handleHoverRight}
                                  handleClickRight={this.handleClickRight}
                                  handleUnhoverRight={this.handleUnhoverRight}
                                  selectedtab={this.state.lhpFactor}
                                  school_bar_change={this.handleschoolbarChange}
                                  crime_bar_change={this.handlecrimebarChange}
                                  town_bar_change={this.handletownbarChange}
                                  curb_bar_change={this.handletownbarChange}
                                  walk_bar_change={this.handlewalkbarChange}
                                  comm_bar_change={this.handlecommbarChange}
                                  value_bar_change={this.handlevaluebarChange}
                                  pricemax_change={this.handlepricemaxChange}
                                  pricemin_change={this.handlepriceminChange}
                                  heart={this.state.nhheart}
                                  save={this.getsavednhdata}
                                  checkPersonal={this.handlecheckpersonal}
                                  personal_txt={this.state.personal_txt}
                                  lmodal={this.state.lmodal}
                                  smodal={this.state.smodal}
                                  loggedin_user_id={this.state.userId}
                                  personalize_data={this.state.personalize_data}
                                  selectedpersonaldata={
                                    this.state.selectedpersonaldata
                                  }
                                  handlesinglecancel={this.handlesinglecancel}
                                  is_from_personal={this.state.is_from_personal}
                                  isMobile={this.state.isMobile}
                                  nhsaved={this.state.nhsaved}
                                  is_edit_click={this.state.is_edit_click}
                                  handleClosepersonal={this.handleClosepersonal}
                                  handlefilterclick={this.handlefilterclick}
                                  citycentername={this.state.CentercityName}
                                  postalcityfullname={
                                    this.state.postalcityfullname
                                  }
                                  countyname={this.state.CentercountyName}
                                  countyfullname={this.state.countyfullname}
                                />
                              ) : (
                                <div style={{ width: "100%", height: "100%" }}>
                                  <img
                                    src={
                                      process.env.NEXT_PUBLIC_CDN_ID +
                                      "static/images/default-right.png"
                                    } // replace with your image path
                                    alt="Loading..."
                                    style={{
                                      maxWidth: "100%",
                                      height: "auto",
                                      // objectFit: "cover",
                                    }}
                                  />
                                </div>
                              )}

                              <div className="mt-30">
                                <LandingFooter />
                              </div>
                            </Tab.Pane>
                          ),
                        },
                        {
                          menuItem: "Homes",
                          render: () => (
                            <>
                              <Grid style={{ marginBottom: "10px" }}>
                                <Grid.Column
                                  width={16}
                                  style={{
                                    textAlign: "center",
                                    paddingBottom: "0px",
                                    paddingTop: "10px",
                                  }}
                                >
                                  <Grid.Row>
                                    <Button
                                      primary
                                      id="filter_btn"
                                      onClick={this.filterHome}
                                    >
                                      Filter Homes
                                    </Button>
                                  </Grid.Row>
                                </Grid.Column>
                              </Grid>
                              <Tab.Pane
                                style={{
                                  overflowY: "scroll",
                                  height: this.state.height + tabPadding,
                                }}
                                className="tab_content home_section"
                              >
                                {this.renderMapButton()}

                                <Homes
                                  data={this.state.homesdata}
                                  saveddata={this.state.savedhomedata}
                                  ref={this.homesRef}
                                  homesingledata={this.state.singlehomedata}
                                  selectedData={this.state.selectedNeighbour}
                                  filterHome={this.state.filterHome}
                                  getdatafromhomes={this.getdatafromhomes}
                                  getfiltersdata={this.state.getdatafromhomes}
                                  userdata={this.state.userdata}
                                  userId={this.state.userId}
                                  save={this.getsavedhomedata}
                                  heart={this.state.heart}
                                  handleHomesHoverRight={
                                    this.handleHomesHoverRight
                                  }
                                  handleHomesUnhoverRight={
                                    this.handleHomesUnhoverRight
                                  }
                                  filter_homes_count={
                                    this.state.filter_homes_count
                                  }
                                  is_from_personal={this.state.is_from_personal}
                                  nhsaved={this.state.nhsaved}
                                  zoomlevel={this.state.zoom}
                                  citycentername={this.state.CentercityName}
                                  postalcityfullname={
                                    this.state.postalcityfullname
                                  }
                                  countyname={this.state.CentercountyName}
                                  countyfullname={this.state.countyfullname}
                                ></Homes>
                                <div className="mt-30">
                                  <LandingFooter />
                                </div>
                              </Tab.Pane>
                            </>
                          ),
                        },
                      ]}
                      activeIndex={this.state.rhpFactor}
                    />
                  </Grid.Column>
                </Grid>
                {/* <div style={{ marginTop: 30 }}>
            {this.state.lhpFactor === 8 &&
            (localStorage.objAddNeighbourSearch &&
              localStorage.objAddNeighbourSearch !== null &&
              localStorage.objAddNeighbourSearch !== undefined) ? (
              <Link href="/PersSearch">
                <Button primary content={'Change Personal Criteria'} />
              </Link>
            ) : null}
          </div> */}

                {/* <LoginModal
                open={lmodal}
                submit={this.modalSubmit}
                next={this.nextModal}
                iconclick={this.closeModal}
                email_err_status={this.state.email_err_status}
                email_err_msg={this.state.email_err_msg}
                pwd_err_status={this.state.pwd_err_status}
                pwd_err_msg={this.state.pwd_err_msg}
                isChecked={this.state.isChecked}
                emailval={this.state.emailval}
                passval={this.state.passval}
              />
              <SignupModal
                open={smodal}
                submit={this.modalSubmit}
                next={this.nextModal}
                iconclick={this.closeModal}
              /> */}
              </Container>
            </Layout>
          </div>
          <FeedbackForm />
          {this.state.isplusatingopen && (
            <div
              className="how-it-work"
              onClick={() => this.handlePlusatingClick()}
            >
              <Button className="ui medium how-it-work-btn">
                How
                <img
                  src={
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/rating_full.png"
                  }
                  className="how_it_work_logo_img"
                  alt="Houseberry Logo"
                  width="925"
                  height="26"
                />
                Works
              </Button>
              <div className="how-it-work-arrow-indicator"></div>
            </div>
            /* 
            <div
              className="pulsating_circle_main"
              onClick={() => this.handlePlusatingClick()}
            >
              <div className="pulsating-circle"></div>
            </div>
          */
          )}
          {this.state.landingpopup && (
            <Modal
              isOpen={this.state.landingpopup}
              onRequestClose={this.closeLandingmodal}
              onClick={this.closeLandingmodal}
              // style={customStyles}
              style={this.customStyles}
            >
              <div className="landigPopupmain">
                <div
                  className="close_icon_select close_personal close_perosnal_dnh_nh close_nhmap"
                  onClick={this.closeLandingmodal}
                >
                  <a
                    className="boxclose"
                    id="boxclose"
                    style={{ color: "#fff" }}
                  ></a>
                </div>
                <div className="home_search_main_nh">
                  <p>Find Your Neighborhood First. Then Your Home.</p>
                </div>
                <div className="landing_grid_btm landing_grid_btn_main">
                  <LandingVideo
                    gridData={nhmapgridData}
                    urls=""
                    ispage="nhmap"
                    handleClick={() => this.closeLandingmodal()}
                    isMobile={this.state.isMobile ? true : false}
                  />
                  {/* <LandingGrids
                    gridData={nhmapgridData}
                    urls=""
                    ispage="nhmap"
                    handleClick={() => this.closeLandingmodal()}
                    isMobile={this.state.isMobile ? true : false}
                  /> */}
                </div>
                <div className="landingBtn">
                  <Button primary onClick={() => this.closeLandingmodal()}>
                    Get Started
                  </Button>
                </div>
              </div>
            </Modal>
          )}
        </>
      </ErrorBoundary>
    );
  }
}

export default NhMap;

export async function getStaticProps() {
  return {
    props: {
      query: {},
    },
  };
}
